import { Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { DataService } from '../data.service';
import { Router, ActivatedRoute } from '@angular/router';
import { CountryService } from '../country.service';
import { DecimalPipe } from '@angular/common';
import { parse, format, AsYouType } from 'libphonenumber-js';
import { IMyDpOptions, IMyDateModel, IMyDate } from 'mydatepicker';
// import {clearTimeout, setTimeout} from 'timers';
import { EventsService } from 'angular4-events';
import { Constants } from '../constants';



declare var $: any;
declare var google: any;
declare var Nanobar: any;
declare var toastr: any;

@Component({
  selector: 'app-order-edit',
  templateUrl: './order-edit.component.html',
  styleUrls: ['./order-edit.component.css']
})
export class OrderEditComponent implements OnInit {

  @ViewChild('mapCanvas2') mapElement2: ElementRef;
  priceIconForDouble = Constants.iconForDoublePrice;
  id: any;
  sub: any;

  orderDataDisplay: any;
  orderDetailData: any;
  customerDetail: any;
  droppOffAddress: any;
  pickupAddress: any;
  OrderproductData: any;
  thirdPartyData: any;
  onDetailDriverData: any;
  delivery_charges: any;
  isFreeDelivery: any;

  clearTimeout: any;
  clearTimeoutCustomer: any;
  searchString: any;
  numChk = false;
  countryCode: any;
  searchStringCustomer: any;
  searchStringOutlet: any;
  productData: any;
  customerData: any;
  outletData: any;
  outletNationWide: any;
  customerDataLength: any;
  productDataLength: any;
  outletDataLength: any;
  restErrorCode: any;
  productDisplayDataArray = new Array();
  customerDisplayDataArray = new Array();
  outletDisplayDataArray = new Array();
  calculationArray = new Array();
  nao = new Nanobar();
  quantityTotal: any;
  CustomerSearchBox = true;
  editAddress = false;
  outletSearchBox = true;
  totalPrice: any;
  subTotal: any;
  charges: any;
  myTemp: any;
  discount: any;
  fieldDisable = true;
  chargeFieldDisable = true;
  notes: any;
  finalProduct = new Array();
  outletAddress: any;
  deliveryAddress: any;
  finalQuantity: any;
  // tax_charges = 10;
  tax_charges: any;
  tax_chargesToDisplay: any;
  orderSuccess: any;
  orderMessage: any;
  orderStatus: any;
  totalPriceDiscount: any;
  place: any;
  address: any;
  placeForEditAddress: any;
  prefilledCustomerData: any;
  // customer add variables
  first_name: any;
  last_name: any;
  number: any;
  email: any;
  is_tax_exempt = false;
  accept_marketing = false;
  address_line1: any;
  address_line2: any;
  latitude: any;
  longitude: any;
  street: any;
  street3: any;
  city: any;
  state: any;
  zip: any;
  area: any;
  apart: any;
  note: any;
  dob: any;
  preventCall = false;
  private today = new Date();
  selDate: any;
  platform_fee_waive_off: any;
  count = 0;
  myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'mm/dd/yyyy',
    showTodayBtn: true,
    todayBtnTxt: 'Today',
    showClearDateBtn: false,
    indicateInvalidDate: true,
    editableDateField: false,
    openSelectorOnInputClick: true,
    disableSince: { year: this.today.getFullYear() - 20, month: 1, day: 1 },
    // minYear: this.today.getFullYear() - 20,
    // disableSince: {year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() + 1}
    // disableUntil: {year: 0, month: 0, day: 0}
  };
  success: any;
  addingCustomer = false;
  numberChkError: any;
  btnDisableOrder = false;
  error_count: any;
  emailChk: any;
  findCustomerData: any;
  customerMatch = false;
  mycharges: any;
  latitude2: any;
  longitude2: any;
  createorderResponseUpdate: any;
  createorderResponse: any;
  updateError: any;
  btnDisable = false;
  maxYear: any;
  placeSuggestionsData: any;
  placeDetailData: any;
  placeDataFound = false;
  addressLoad = false;
  placeSuggestionsData2: any;
  placeDetailData2: any;
  placeDataFound2 = false;
  addressLoad2 = false;
  platformFeeData: any;
  map2: any;
  customerLat: any;
  customerLong: any;
  outletLat: any;
  outletLong: any;
  mapEle2: any;
  markerDrivers = new Array();
  markerCustomer = new Array();
  dispensaryData: any;
  isNation: any;
  isLocal: any;
  delivery_man_type: any;
  customerPrimeryCardNo = '';
  paymentThroughCard: any;
  paymentThroughCash: any;
  paymentMethodOptionValue = -1;
  paymentCardData: any;
  primaryCardNo = '';
  removeCardData: any;
  primaryDataSuccess: any;
  cardNum: any;
  cardName: any;
  expiryDate: any;
  card_cvv: any;
  cardType: any;
  expiryDateError = 0;
  cardSuccess: any;
  cardMessage: any;
  order_detail_id: any;
  businessProfileData: any;
  messages: any = { validDate: 'valid\ndate', monthYear: 'mm/yyyy' };
  placeholders: any = { number: '•••• •••• •••• ••••', name: 'Full Name', expiry: '••/••', cvc: '•••' };
  masks: any;
  deleteCardNoId: any;
  showPaymentView = false;
  disabledClick: any;
  selectAddress = false;
  selectAddressCustomer = false;
  customerAddressList = [];
  selectedCustomerId: any;
  selectedCustomerObj: any;
  placeLabel = '';
  CustomeplaceLabel = '';
  placeLabelDefault = '';
  placeLabelError = '';
  idval: any;
  todayData1 = new Date();
  todayData = this.todayData1.getDay();
  timeSlotDetail: any;
  outletIdToSendInCheckout: any;
  over_night_charges: any;
  days_charges: any;
  timeSlotDetail_delivery: any;
  businessTypeFromSlotRequest: any;
  timeSlotDetail_delivery_show = new Array();
  timeSlotDetail_delivery_charges = 0;
  third_party_string = '';
  dayOfGivenTime = '';
  dayIndex: any;
  time: any;
  overnight = '';
  slotSuccessMessage = '';
  clearTimeoutProduct: any;
  slotSuccess: any;
  freeCount = 0;
  infoData: any;
  breakdownCharges = 0;
  breakdownChargesTotal = 0;
  breakdownChargesDis = 0;
  timeSlotDetailOrignal: any;
  showBreakdownIcon = false;
  houseNo: any;
  editHouseNo: any;
  editAddressId: any;
  dispensary_id: any;
  noOptionsPrice: number;
  addItValue: number;
  actualPrice: number;
  productModifierDataArray = new Array;
  ind: any;
  modifiersArr = new Array;
  addonsArr = new Array;
  noOptionsArr = new Array;
  priceAddon: any;
  variantPrice: any;
  varianId: any;
  changeCheck: any = 'temporary';
  variantName: any;
  check: any = false;
  variantNameCheck: any = 'temporary';
  variantOptionName: any;
  timeSlotDetail_delivery_charges_actual = 0;
  gender: any = -1;
  isDineIn: any;
  isPickUp: any;
  multipleOptions: boolean = false;
  nationLocal: boolean;
  nationPick: boolean;
  nationDine: boolean;
  dinePick: boolean;
  localDine: boolean;
  localPick: boolean;
  nationLocalDine: boolean;
  localDinePick: boolean;
  nationlocalPick: boolean;
  nationDinePick: boolean;
  business_type: any;
  isPickUpVal: boolean;
  isDineInVal: boolean;
  isLocalVal: boolean;
  isNationVal: boolean;
  selectedCheckbox: boolean;
  pickUpCheck: boolean = false;
  paymentMethod: any;
  cash_tax: number;
  card_tax: number;
  cash_check: boolean;
  card_check: boolean;
  buisnessAlreadyCollect:boolean;
  tempTax: any;
  tempPaymentMethod: number;
  tempCharges: boolean = false;
  final_answer: number;
  paymentThroughBankTransfer: string;
  paymentThroughMpos: string;
  bank_check: boolean;
  mos_check: boolean;
  calculating = false;

  constructor(private dataService: DataService, private cs: CountryService, private router: Router, private chRef: ChangeDetectorRef, private events: EventsService, private route: ActivatedRoute) {

    this.sub = this.route.params.subscribe(params => {
      this.id = params['id']; // (+) converts string 'id' to a number
      console.log('this.id', this.id);
    });

    this.subTotal = 0;
    // this.tax_chargesToDisplay = 0;
    this.discount = 0;

    if (window.localStorage.getItem('isauthenticated') !== 'true') {
      this.router.navigate(['/']);
    }
    if (window.localStorage.getItem('userRole') === '3' && window.localStorage.getItem('isauthenticated') === 'true') {
      this.router.navigate(['orders']);
    }
    setTimeout(() => {
      this.maxYear = new Date().getFullYear();
      this.maxYear = parseInt(this.maxYear, 10) - 21;
      this.selDate = '01/01/' + this.maxYear;
      this.dob = this.selDate;
    }, 1500);
    this.dataService.routeView = 'orders';
    this.dataService.routeViewOutlet = 'orders';

    $('.AddNewAddressCustomerMain').css('display', 'none');
    $('.createOrderPageMain').css('display', 'bloack');

    this.idval = this.events.subscribe('AddAddressCustomerDone').subscribe((data) => {
      console.log('in create order');
      var number = this.selectedCustomerObj.id;
      this.prefindCustomerForDisplayData(number);
    });

    $('.AddNewAddressCustomerMain').css('display', 'none');
    $('.createOrderPageMain').css('display', 'bloack');





  }
  get_dispensary_information() {
    this.dataService.dispensary_information(window.localStorage.getItem('token'), this.dispensary_id).subscribe(
      (data) => {
        this.dispensaryData = data;
        this.isNation = this.dispensaryData.is_nation_wide;
        this.isLocal = this.dispensaryData.is_local;
        this.isDineIn = this.dispensaryData.is_dine_in_available;
        this.isPickUp = this.dispensaryData.is_pickup_order_available;
        if (this.business_type === 1) {
          this.selectedCheckbox = true;
          if (this.delivery_man_type === 3) {
            $('#delivery_address').css('display', 'block');
            this.isNationVal = true;
            this.isLocalVal = false;
            this.isDineInVal = false;
            this.isPickUpVal = false;
          }
          if (this.delivery_man_type === 1) {
            $('#delivery_address').css('display', 'block');
            this.isNationVal = false;
            this.isLocalVal = true;
            this.isDineInVal = false;
            this.isPickUpVal = false;
          }
          if (this.delivery_man_type === 4) {
            $('#delivery_address').css('display', 'none');
            this.charges = 0;
            this.pickUpCheck = true;
            this.isNationVal = false;
            this.isLocalVal = false;
            this.isDineInVal = true;
            this.isPickUpVal = false;
          }
          if (this.delivery_man_type === 5) {
            $('#delivery_address').css('display', 'none');
            this.charges = 0;
            this.pickUpCheck = true;
            this.isNationVal = false;
            this.isLocalVal = false;
            this.isDineInVal = false;
            this.isPickUpVal = true;
          }
        }
        if (this.business_type === 0) {
          this.isNation = true;
          this.isLocal = false;
        }
        this.clearTimeout = setTimeout(() => {
          if ((this.isNation === true && this.isLocal === true)) {
            this.nationLocal = true;
          }
          if ((this.isNation === true && this.isPickUp === true)) {
            this.nationPick = true;
          }
          if ((this.isNation === true && this.isDineIn === true)) {
            this.nationDine = true;
          }
          if ((this.isDineIn === true && this.isPickUp === true)) {
            this.dinePick = true;
          }
          if ((this.isLocal === true && this.isDineIn === true)) {
            this.localDine = true;
          }
          if ((this.isLocal === true && this.isPickUp === true)) {
            this.localPick = true;
          }
          if ((this.isNation === true && this.isLocal === true && this.isDineIn === true && this.isPickUp === false)) {
            this.nationLocalDine = true;
          }
          if ((this.isNation === false && this.isLocal === true && this.isDineIn === true && this.isPickUp === true)) {
            this.localDinePick = true;
          }
          if ((this.isNation === true && this.isLocal === true && this.isDineIn === false && this.isPickUp === true)) {
            this.nationlocalPick = true;
          }
          if ((this.isNation === true && this.isLocal === false && this.isDineIn === true && this.isPickUp === true)) {
            this.nationDinePick = true;
          }
          if ((this.isNation === true && this.isLocal === true && this.isDineIn === true && this.isPickUp === true)) {
            this.multipleOptions = true;
          }
          // console.log('delivery_man_typedelivery_man_typedelivery_man_typedelivery_man_type', this.delivery_man_type);
        }, 2000);
      },
      (error) => {
        console.log('error', error);
      }
    );
  }
  updateDeliveryFunc(val) {
    if (val === '1') {
      $('.isNation').prop('checked', false);
      $('.isDineIn').prop('checked', false);
      $('.isPickUp').prop('checked', false);
      this.delivery_man_type = 1;
    }
    if (val === '3') {
      $('.isLocal').prop('checked', false);
      $('.isDineIn').prop('checked', false);
      $('.isPickUp').prop('checked', false);
      this.delivery_man_type = 3;
    }
    if (val === '4') {
      $('.isLocal').prop('checked', false);
      $('.isNation').prop('checked', false);
      $('.isPickUp').prop('checked', false);
      this.delivery_man_type = 4;
    }
    if (val === '5') {
      $('.isLocal').prop('checked', false);
      $('.isNation').prop('checked', false);
      $('.isDineIn').prop('checked', false);
      this.delivery_man_type = 5;
    }
    if ($('.isLocal').prop('checked') === false && $('.isNation').prop('checked') === false && $('.isDineIn').prop('checked') === false && $('.isPickUp').prop('checked') === false) {
      this.delivery_man_type = 0;
    }
  }
  searchProductOnOrder() {
    clearTimeout(this.clearTimeoutProduct);
    this.clearTimeoutProduct = setTimeout(() => {
      this.nao.go(30);
      console.log('login data');
      this.dataService.searchProducts(window.localStorage.getItem('token'), this.searchString, this.dispensary_id).subscribe(
        (data) => {
          this.nao.go(100);
          console.log('this.productData', this.productData);
          console.log('products data', data);
          if (this.searchString === '') {
            this.productData = [];
            this.productDataLength = undefined;
          } else {
            this.productData = data;
            // this.productData = this.productData.items;
            this.productDataLength = this.productData.length;
          }
        },
        (error) => {
          this.nao.go(100);
          console.log('error', error);
        }
      );
    }, 1000);
  }
  platformFeeWaivedOffFtn() {
    this.count++;
    if (this.count % 2 != 0) {
      this.platform_fee_waive_off = true;
    }
    else {
      this.platform_fee_waive_off = false;

    }

  }
  searchCustomerOnOrder() {
    clearTimeout(this.clearTimeoutCustomer);
    this.clearTimeoutCustomer = setTimeout(() => {
      this.nao.go(30);
      console.log('login data');
      this.dataService.searchCustomers(window.localStorage.getItem('token'), this.searchStringCustomer, this.dispensary_id).subscribe(
        (data) => {
          this.nao.go(100);
          console.log('products data', data);
          if (this.searchStringCustomer === '') {
            this.customerData = [];
          } else {
            this.customerData = data;
            this.customerData = this.customerData.items;
            this.customerDataLength = this.customerData.length;
            for (var i = 0; i < this.customerData.length; i++) {
              if (this.customerData[i].country_code === '+1') {
                this.customerData[i].phone_number = format(this.customerData[i].phone_number, 'US', 'NATIONAL');
                console.log('this.driverData[i].number', this.customerData[i].phone_number);
              }
            }
          }
        },
        (error) => {
          this.nao.go(100);
          console.log('error', error);
        }
      );
    }, 1000);
  }
  showmap() {
    const contax = this;
    $('#map2').css('display', 'block');
    this.chRef.detectChanges();
    this.mapEle2 = this.mapElement2.nativeElement;

    var lat = this.outletData[0].latitude;
    var long = this.outletData[0].longitude;

    this.map2 = new google.maps.Map(this.mapEle2, {
      zoom: 13,
      center: { lat: lat, lng: long },
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: true,
      zoomControl: true,
      scaleControl: true
    });
    google.maps.event.addListenerOnce(this.map2, 'idle', () => {
      this.mapEle2.classList.add('show-map');
    });
    var endImage = {
      url: 'assets/drop_pin-bucket.png', // url
      scaledSize: new google.maps.Size(50, 56), // scaled size
      origin: new google.maps.Point(0, 0), // origin
      anchor: new google.maps.Point(16, 16) // anchor
    };
    var orderDeliveryIcon = {
      url: 'assets/pin-green.png', // url
      scaledSize: new google.maps.Size(30, 30), // scaled size
      origin: new google.maps.Point(0, 0), // origin
      anchor: new google.maps.Point(16, 16) // anchor
    };
    var deliveryDriverIcon = {
      url: 'assets/new-van.png', // url
      scaledSize: new google.maps.Size(40, 46), // scaled size
      origin: new google.maps.Point(0, 0), // origin
      anchor: new google.maps.Point(16, 16) // anchor
    };
    setTimeout(() => {
      if (this.customerDisplayDataArray.length > 0) {
        if (this.customerDisplayDataArray[0].is_default === true) {
          console.log('in map functon', this.customerDisplayDataArray[0]);
          var boundsOrder = new google.maps.LatLngBounds();

          this.chRef.detectChanges();
          var latCustomer = Number(this.customerDisplayDataArray[0].latitude);
          var longCustomer = Number(this.customerDisplayDataArray[0].longitude);
          console.log('latCustomer, longCustomer', latCustomer, longCustomer);
          this.chRef.detectChanges();

          var locationDriver = new google.maps.LatLng(latCustomer, longCustomer);
          boundsOrder.extend(locationDriver);
          this.markerDrivers[0] = new google.maps.Marker({
            position: locationDriver,
            map: this.map2,
            icon: orderDeliveryIcon,
            zoom: 13
          });
          this.chRef.detectChanges();
        }
      }
    }, 1000);
    setTimeout(() => {
      if (this.outletDisplayDataArray.length === 0) {
        if (this.outletNationWide === true) {
          if (this.outletData.length > 0) {
            for (var i = 0; i < this.outletData.length; i++) {
              if (this.outletData[i].outlet_type === 0 && this.outletData[i].outlet_type === 0) {
                var boundsOutlet = new google.maps.LatLngBounds();
                var locationOutlet = new google.maps.LatLng(this.outletData[i].latitude, this.outletData[i].longitude);
                boundsOutlet.extend(locationOutlet);
                this.markerDrivers[i] = new google.maps.Marker({
                  position: locationOutlet,
                  map: this.map2,
                  icon: endImage,
                  zoom: 13
                });
              }
            }
          }
        }
        if (this.outletNationWide === false) {
          if (this.outletData.length > 0) {
            for (var i = 0; i < this.outletData.length; i++) {
              if (this.outletData[i].outlet_type === 0) {
                var boundsOutlet = new google.maps.LatLngBounds();
                var locationOutlet = new google.maps.LatLng(this.outletData[i].latitude, this.outletData[i].longitude);
                boundsOutlet.extend(locationOutlet);
                this.markerDrivers[i] = new google.maps.Marker({
                  position: locationOutlet,
                  map: this.map2,
                  icon: endImage,
                  zoom: 13
                });
              }
            }
          }
        }
      } else {
        if (this.outletDisplayDataArray[0].outlet_type === 0) {
          var boundsOutlet = new google.maps.LatLngBounds();
          var locationOutlet = new google.maps.LatLng(this.outletDisplayDataArray[0].latitude, this.outletDisplayDataArray[0].longitude);
          boundsOutlet.extend(locationOutlet);
          this.markerDrivers[0] = new google.maps.Marker({
            position: locationOutlet,
            map: this.map2,
            icon: endImage,
            zoom: 13,
            center: { lat: this.outletDisplayDataArray[0].latitude, lng: this.outletDisplayDataArray[0].longitude }
          });
        }
      }
    }, 1000);
  }
  // outletDisplayDataArray
  searchOutletOnOrder() {
    console.log('login data');
    this.dataService.searchOutletsList(window.localStorage.getItem('token'), this.searchStringOutlet, this.dispensary_id).subscribe(
      (data) => {
        console.log('products data', data);
        if (this.searchStringOutlet === '') {
          this.outletData = [];
        } else {
          this.outletData = data;
          this.outletNationWide = this.outletData.is_nation_wide;
          this.outletData = this.outletData.items;
          this.outletDataLength = this.outletData.length;
          for (var i = 0; i < this.outletData.length; i++) {
            if (this.outletData[i].country_code === '+1') {
              this.outletData[i].phone_number = format(this.outletData[i].phone_number, 'US', 'NATIONAL');
              console.log('this.driverData[i].number', this.outletData[i].phone_number);
            }
          }
          // this.showmap();
          this.showDistance();
        }
      },
      (error) => {
        console.log('error', error);
      }
    );
  }
  selectProduct(id, variantId) {
    if (this.pickUpCheck == true) {
      this.charges = 0;
    }
    this.searchString = '';
    console.log('id chk on slect product', id);
    console.log('product data on sleect product', this.productData);

    for (var i = 0; i < this.productDataLength; i++) {
      if (this.productData[i].id === id && this.productData[i].has_modifier === false) {
        if (this.productData[i].variant[0].id === variantId) {
          var obj = {
            quantityTotal: 1,
            id: this.productData[i].id,
            name: this.productData[i].name,
            image: this.productData[i].image,
            variantName: this.productData[i].variant[0].option_name,
            order_detail_id: this.productData[i].order_detail_id,
            optionValue: this.productData[i].variant[0].option_value,
            inventory_count: this.productData[i].inventory_count,
            cash_tax: this.productData[i].variant[0].cash_tax_percentage,
            card_tax: this.productData[i].variant[0].card_tax_percentage,
            price: Math.round(this.productData[i].variant[0].price),
            compare_price: Math.round(this.productData[i].variant[0].compare_price),
            is_on_sale: this.productData[i].variant[0].is_on_sale,
            variant_id: this.productData[i].variant[0].id,
            modifier_price_calculation: 0,
            modifier_price_calculation_single: 0,
            error_msg: ''
          };
          // Checking Same Varient //
          var index: any;
          let returnObj = this.checkObjectVariant(this.productDisplayDataArray, obj);
          if (returnObj.value === false) {

            this.productDisplayDataArray.push(obj);
            index = this.productDisplayDataArray.indexOf(obj);
          }
          else {

            if (returnObj.index === -1) {
              index = this.productDisplayDataArray.indexOf(obj);
              this.productDisplayDataArray[index]['quantityTotal'] += 1;
            }
            else {
              index = returnObj.index;
              this.productDisplayDataArray[returnObj.index]['quantityTotal'] += 1;
            }
          }
          /*   if (this.checkObjectVariant(this.productDisplayDataArray, obj) === false) {
               this.productDisplayDataArray.push(obj);
          }*/
          //const index = this.checkValUpdateVariant(this.productDisplayDataArray, obj);
          //this.productCalculation(this.productDisplayDataArray[index].variant_id, this.productDisplayDataArray[index].price, this.productDisplayDataArray[index].quantityTotal, index);
          this.reInitializeCalculationArray();
        }
      } else if (this.productData[i].id === id && this.productData[i].has_modifier === true) {
        let obj = {
          quantityTotal: 1,
          id: this.productData[i].id,
          name: this.productData[i].name,
          image: this.productData[i].image,
          variantName: this.productData[i].variant[0].option_name,
          optionValue: this.productData[i].variant[0].option_value,
          inventory_count: this.productData[i].inventory_count,
          cash_tax: this.productData[i].variant[0].cash_tax_percentage,
          card_tax: this.productData[i].variant[0].card_tax_percentage,
          price: Math.round(this.productData[i].variant[0].price),
          compare_price: Math.round(this.productData[i].variant[0].compare_price),
          is_on_sale: this.productData[i].variant[0].is_on_sale,
          variant_id: this.productData[i].variant[0].id,
          modifiers: this.productData[i].variant[0].modifiers,
          addons: this.productData[i].variant[0].addons,
          noOption: this.productData[i].variant[0].no_options,
          hasModifier: this.productData[i].has_modifier,
          error_msg: ''
        };
        $('#addVariantsModifiersPop').modal('show');
        let modPrices = 0;
        this.productData[i].variant[0].modifiers.forEach(modElement => {
          for (let i = 0; i < 1; i++) {
            modPrices += modElement.options[0].price;
          }
        });
        let totalNoOptionPrice = 0;
        if (this.productData[i].variant[0].no_options.length > 0 && this.productData[i].variant[0].no_options.options != null) {
          for (let j = 0; j < this.productData[i].variant[0].no_options.options.length; j++) {
            totalNoOptionPrice = totalNoOptionPrice + this.productData[i].variant[0].no_options.options[j].price;
            this.noOptionsPrice = totalNoOptionPrice;
          }
        }
        this.addItValue = Math.round(this.productData[i].variant[0].price) + totalNoOptionPrice + modPrices;
        this.actualPrice = Math.round(this.productData[i].variant[0].price);
        this.productModifierDataArray = new Array;
        this.productModifierDataArray.push(obj);
        console.log(this.productModifierDataArray);
        this.ind = this.productDisplayDataArray.length;
        for (let i = 0; i < this.productModifierDataArray[0].modifiers.length; i++) {
          for (let j = 0; j < 1; j++) {
            this.productModifierDataArray[0].modifiers[i].options[j].selected = true;
            this.modifiersArr.push({
              groupTitle: this.productModifierDataArray[0].modifiers[i].title,
              optionTitle: this.productModifierDataArray[0].modifiers[i].options[j].title,
              optionPrice: this.productModifierDataArray[0].modifiers[i].options[j].price
            });
          }
        }
      }
    }
    console.log('select product array', this.productDisplayDataArray);
    console.log('select product array', this.productModifierDataArray);
    console.log('customerDisplayDataArray in select customer', this.customerDisplayDataArray);
    if (this.customerDisplayDataArray.length > 0) {
      console.log('customerDisplayDataArray', this.customerDisplayDataArray);
      if (this.productDisplayDataArray.length === 1) {
        this.getSlotsDataWithAddress();
      }
    }
    let productLength = this.productDisplayDataArray.length;
    if (productLength != 0) {
      let updateCash = 0;
      let updateCard = 0;
      for (let i = 0; i < productLength; i++) {
        updateCash = this.productDisplayDataArray[i]['cash_tax'];
        updateCard = this.productDisplayDataArray[i]['card_tax'];
      }
      this.cash_tax = updateCash;
      this.card_tax = updateCard;
      if (this.cash_check == true) {

        this.paymentMethodOptionValue = 0;
        // this.tax_charges = this.cash_tax;
        this.tax_chargesToDisplay = this.cash_tax;
      }
      if (this.card_check == true) {

        if (this.bank_check == true) {
          this.paymentMethodOptionValue = 2;
          this.tempPaymentMethod = 2
        }
        if (this.mos_check == true) {
          this.paymentMethodOptionValue = 3;
          this.tempPaymentMethod = 3;
        }
        if (this.bank_check == false && this.mos_check == false) {
          this.paymentMethodOptionValue = 1;
          this.tempPaymentMethod = 1
        }
        this.tax_chargesToDisplay = this.card_tax;
      }
    }
    this.productData = [];
  }

  reInitializeCalculationArray() {
    this.calculationArray = [];
    this.productDisplayDataArray.forEach((element, index) => {

      this.productCalculation(element.variant_id, element.price, element.quantityTotal, element.cash_tax, element.card_tax, index, element.modifier_price_calculation_single);
    });
  }

  editQuantityOrder(variantId, price, quantity, index) {
    clearTimeout(this.clearTimeoutProduct);
    this.clearTimeoutProduct = setTimeout(() => {
      if (quantity == null) {
        this.productDisplayDataArray[index].quantity = 0;
      } else {
        this.productDisplayDataArray[index].quantity = quantity;
        this.reInitializeCalculationArray();
      }
    }, 1000);
    console.log(this.tax_chargesToDisplay);
  }

  editVariantName(variantId, name, variantOptionName) {
    this.variantName = name;
    this.varianId = variantId;
    this.variantOptionName = variantOptionName;
    $('#editVariantNamePop').modal('show');
  }

  updateVariantName(variantId) {
    if (this.variantNameCheck == 'temporary') {
      for (let i = 0; i < this.productDisplayDataArray.length; i++) {
        if (variantId == this.productDisplayDataArray[i].variant_id) {
          this.productDisplayDataArray[i].optionValue = this.variantName;
          this.variantNameCheck = 'temporary';
          $('#editVariantNamePop').modal('hide');
        }
      }
    } else {
      this.dataService.updatePrice(window.localStorage.getItem('token'), variantId, -1, this.variantName).subscribe(
        res => {
          this.check = true;
          this.variantNameCheck = 'temporary';
          if (res['success'] == true) {
            for (let i = 0; i < this.productDisplayDataArray.length; i++) {
              if (variantId == this.productDisplayDataArray[i].variant_id) {
                this.check = false;
                this.productDisplayDataArray[i].optionValue = this.variantName;
                $('#editVariantNamePop').modal('hide');
              }
            }
          }
        },
        err => {
          console.log(err);
        }
      );
    }
  }

  editPrice(variantId, price) {
    this.variantPrice = price;
    this.varianId = variantId;
    $('#editPricePop').modal('show');
  }

  updateVariantPrice(variantId) {
    if (this.changeCheck == 'temporary') {
      for (let i = 0; i < this.productDisplayDataArray.length; i++) {
        if (variantId == this.productDisplayDataArray[i].variant_id) {
          console.log(this.variantPrice);
          this.productDisplayDataArray[i].price = parseInt(this.variantPrice);
          // this.productDisplayDataArray[i].modifier_price_calculation_single = 0;
          this.productDisplayDataArray[i].changeCheck = this.changeCheck;
          this.productDisplayDataArray[i].updatedVariantPrice = this.variantPrice;
          this.changeCheck = 'temporary';
          this.reInitializeCalculationArray();
          $('#editPricePop').modal('hide');
        }
      }
    } else {
      this.dataService.updatePrice(window.localStorage.getItem('token'), variantId, this.variantPrice, '').subscribe(
        res => {
          this.check = true;
          this.changeCheck = 'temporary';
          if (res['success'] == true) {
            for (let i = 0; i < this.productDisplayDataArray.length; i++) {
              if (variantId == this.productDisplayDataArray[i].variant_id) {
                this.check = false;
                this.productDisplayDataArray[i].price = res['variant'].price;
                this.productDisplayDataArray[i].changeCheck = this.changeCheck;
                this.reInitializeCalculationArray();
                $('#editPricePop').modal('hide');
              }
            }
          }
        },
        err => {
          console.log(err);
        }
      );
    }
  }

  selectedProductRemove(index, id) {
    console.log('index', index);
    console.log('id', id);
    if (this.cash_check == true) {
      this.tax_chargesToDisplay = this.tax_chargesToDisplay - this.productDisplayDataArray[index]['cash_tax'];
    }
    if (this.card_check == true) {
      this.tax_chargesToDisplay = this.tax_chargesToDisplay - this.productDisplayDataArray[index]['card_tax'];
    }

    this.productDisplayDataArray.splice(index, 1);

    // console.log('this.productDisplayDataArray', this.productDisplayDataArray);
    // this.productDataLength = this.productDisplayDataArray.length;
    this.reInitializeCalculationArray();
    // console.log('productDisplayDataArray', this.productDisplayDataArray, this.productDataLength);
    // var indexTemp = this.checkValUpdateById(this.calculationArray, id);
    // console.log('indexTemp', indexTemp);
    // this.calculationArray.splice(indexTemp, 1);
    // console.log('calculationArray', this.calculationArray);
    setTimeout(() => {
      if (this.productDisplayDataArray.length === 0) {
        this.slotSuccessMessage = '';
        this.timeSlotDetail_delivery = [];
        var emptyArray = [];
        this.timeSlotDetail_delivery_show = JSON.parse(JSON.stringify(emptyArray));
        this.dayOfGivenTime = '';
        this.overnight = '';
        this.timeSlotDetail = null;
        this.dayIndex = null;
        this.outletIdToSendInCheckout = null;
        this.third_party_string = '';
        this.time = null;
        this.businessTypeFromSlotRequest = null;
        this.timeSlotDetail_delivery_charges = 0;
        this.platformFeeData.delivery_charges = this.timeSlotDetail_delivery_charges;
        if (this.pickUpCheck == true) {
          this.charges = 0;
        }
        else {
          this.charges = this.platformFeeData.delivery_charges + this.platformFeeData.platform_fee;
        }
        // this.charges = this.platformFeeData.delivery_charges + this.platformFeeData.platform_fee;
        this.totalPrice = 0;
        this.discountFunction();
      }
      this.calculateTotalPrice();
      this.discountFunction();
      this.chargesFunction();
    }, 1000);
  }
  selectCustomer(id) {
    this.customerDisplayDataArray = [];
    window.localStorage.setItem('client_id', id);
    for (var i = 0; i < this.customerDataLength; i++) {

      if (this.customerData[i].id === id) {
        this.selectedCustomerId = id;
        this.selectedCustomerObj = this.customerData[i];
        console.log('address_list', this.selectedCustomerObj);
        this.freeCount = this.selectedCustomerObj.free_delivery_count;
        this.customerAddressList = this.selectedCustomerObj.address_list.address_dictionary;
        this.customerDisplayDataArray.push({
          id: this.selectedCustomerObj.id,
          first_name: this.selectedCustomerObj.first_name,
          last_name: this.selectedCustomerObj.last_name,
          payments: this.selectedCustomerObj.payments,
          email: this.selectedCustomerObj.email,
          country_code: this.selectedCustomerObj.country_code,
          phone_number: this.selectedCustomerObj.phone_number,
          address: '',
          street: '',
          city: '',
          state: '',
          area: '',
          zip: '',
          apart_no: '',
          longitude: 0,
          latitude: 0,
          is_default: false,
          place_label: '',
          address_id: null
        });
        for (var j = 0; j < this.selectedCustomerObj.address_list.address_dictionary.length; j++) {
          if (this.selectedCustomerObj.address_list.address_dictionary[j].is_default === true) {
            this.customerDisplayDataArray = [];
            this.customerDisplayDataArray.push({
              id: this.selectedCustomerObj.id,
              first_name: this.selectedCustomerObj.first_name,
              last_name: this.selectedCustomerObj.last_name,
              payments: this.selectedCustomerObj.payments,
              email: this.selectedCustomerObj.email,
              country_code: this.selectedCustomerObj.country_code,
              phone_number: this.selectedCustomerObj.phone_number,
              address: this.selectedCustomerObj.address_list.address_dictionary[j].address_line1,
              street: this.selectedCustomerObj.address_list.address_dictionary[j].address_line1,
              city: this.selectedCustomerObj.address_list.address_dictionary[j].city,
              state: this.selectedCustomerObj.address_list.address_dictionary[j].state,
              area: this.selectedCustomerObj.address_list.address_dictionary[j].country,
              zip: this.selectedCustomerObj.address_list.address_dictionary[j].zip,
              apart_no: this.selectedCustomerObj.address_list.address_dictionary[j].apart_no,
              longitude: this.selectedCustomerObj.address_list.address_dictionary[j].longitude,
              latitude: this.selectedCustomerObj.address_list.address_dictionary[j].latitude,
              is_default: this.selectedCustomerObj.address_list.address_dictionary[j].is_default,
              house_building_no: this.prefilledCustomerData.address_list.address_dictionary[j].house_building_no,
              place_label: this.selectedCustomerObj.address_list.address_dictionary[j].place_label,
              address_id: this.selectedCustomerObj.address_list.address_dictionary[j].id
            });
            // this.showmap();
            this.showDistance();
          }
        }
      }
    }

    this.getPayementCard();
    if (this.productDisplayDataArray.length > 0) {
      this.getSlotsDataWithAddress();
    }
    // this.CustomerSearchBox = false;
    $('.CustomerSearchBoxHide').css('display', 'block');
    $('.CustomerSearchBoxShow').css('display', 'none');




    $('#paymentNoCheck-1').css('display', 'none');

    this.chRef.detectChanges();
  }
  selectAddressCustomerFun(address) {
    this.dataService.setPrimaryCustomerAddress(window.localStorage.getItem('token'), this.selectedCustomerObj.id, address.id).subscribe(
      (data) => {
        var number = this.selectedCustomerObj.id;
        // var number =  this.selectedCustomerObj.country_code + this.selectedCustomerObj.phone_number;
        // number = number.replace('(', '');
        // number = number.replace(')', '');
        // number = number.replace('-', '');
        // number = number.replace(/\s/g, '');
        this.prefindCustomerForDisplayData(number);
      },
      (error) => {
        console.log('error', error);
      }
    );

  }
  deliveryMethodConform(id, value) {
    if(this.calculating) return;
    let productLength = this.productDisplayDataArray.length;
    if (productLength > 0) {
      let updateCash = 0;
      let updateCard = 0;
      for (let i = 0; i < productLength; i++) {
        updateCash += this.productDisplayDataArray[i]['cash_tax'];
        updateCard += this.productDisplayDataArray[i]['card_tax'];
      }
      this.cash_tax = updateCash;
      this.card_tax = updateCard;
    }
    if (this.preventCall === false) {
      console.log('this.showPaymentView1', this.showPaymentView);
      if (this.showPaymentView === false) {
        console.log('this.showPaymentView2', this.showPaymentView);
        return;
      }
      $('#paymentNoCheck-cash').css('display', 'none');
      this.cash_check = false;
      for (let i = 0; i < this.paymentCardData.length; i++) {
        $('#paymentNoCheck' + i).css('display', 'none');
      }
      if (value === -1) {
        this.paymentMethodOptionValue = 0;
        $('#paymentNoCheck-cash').css('display', 'inline-block');
        $('#paymentNoCheck-mpos').css('display', 'none');
        $('#paymentNoCheck-bank').css('display', 'none');
        $("#paymentNoCheck-alreadyPaid").css("display", "none");
        this.card_check = false;
        this.cash_check = true;
        this.bank_check = false;
        this.mos_check = false;
        this.buisnessAlreadyCollect=false;
        console.log('paymentMethodOptionValue', this.paymentMethodOptionValue);
      } else if (value === -2) {
        this.paymentMethodOptionValue = 2;
        this.bank_check = true;
        this.cash_check = true;
        this.card_check = false;
        this.mos_check = false;
        this.buisnessAlreadyCollect=false;
        $('#paymentNoCheck-bank').css('display', 'inline-block');
        $('#paymentNoCheck-cash').css('display', 'none');
        $('#paymentNoCheck-mpos').css('display', 'none');
        $("#paymentNoCheck-alreadyPaid").css("display", "none");
      } else if (value === -3) {
        this.paymentMethodOptionValue = 3;
        this.mos_check = true;
        this.card_check = true;
        this.cash_check = false;
        this.bank_check = false;
        this.buisnessAlreadyCollect=false
        $('#paymentNoCheck-mpos').css('display', 'inline-block');
        $('#paymentNoCheck-bank').css('display', 'none');
        $('#paymentNoCheck-cash').css('display', 'none');
        $("#paymentNoCheck-alreadyPaid").css("display", "none");
      } else if (value === -4) {
        this.paymentMethodOptionValue = 4;
        this.tempPaymentMethod = 4;
        this.mos_check = false;
        this.card_check = true;
        this.cash_check = false;
        this.bank_check = false;
        this.buisnessAlreadyCollect=true;
        $('#paymentNoCheck-mpos').css('display', 'none');
        $('#paymentNoCheck-bank').css('display', 'none');
        $('#paymentNoCheck-cash').css('display', 'none');
        $("#paymentNoCheck-alreadyPaid").css("display", "inline-block");
      } else {
        $('#paymentNoCheck-mpos').css('display', 'none');
        $('#paymentNoCheck-bank').css('display', 'none');
        $('#paymentNoCheck-cash').css('display', 'none');
        $("#paymentNoCheck-alreadyPaid").css("display", "none");
        this.cash_check = false;
        this.card_check = true;
        this.mos_check=false;
        this.paymentMethodOptionValue = 1;
        this.tempPaymentMethod = 1
        this.nao.go(30);
        this.preventCall = true;
        this.dataService.makePaymentMethodPrimaryCustomer(window.localStorage.getItem('token'), id, this.customerDisplayDataArray[0].id).subscribe(
          (data) => {
            this.nao.go(100);
            this.primaryDataSuccess = data;
            if (this.primaryDataSuccess.success === true) {
              toastr.success(this.primaryDataSuccess.message);
              for (let i = 0; i < this.paymentCardData.length; i++) {
                this.paymentCardData[i].primary = false;
                $('#paymentNoCheck' + i).css('display', 'none');
              }
              $('#paymentNoCheck' + value).css('display', 'inline');
              this.paymentCardData[value].primary = true;
              this.preventCall = false;
            }
          },
          (error) => {
            this.nao.go(100);
            toastr.error('Some thing went wrong');
          }
        );

      }
    }
    if (this.cash_check == true) {
      if (this.bank_check == true) {
        this.paymentMethodOptionValue = 2;
        this.tempPaymentMethod = 2;
      }

      if(this.bank_check == false) {
        this.paymentMethodOptionValue = 0;
        this.tempPaymentMethod = 0;
      }
      // this.paymentMethodOptionValue = 0;
      // this.tax_charges = this.cash_tax;
      this.tax_chargesToDisplay = this.cash_tax;
    }
    if (this.card_check == true) {
      if (this.mos_check == true) {
        this.paymentMethodOptionValue = 3;
        this.tempPaymentMethod = 3
      }
      if (this.mos_check == false &&  this.buisnessAlreadyCollect==false) {
        this.paymentMethodOptionValue = 1;
        this.tempPaymentMethod = 1
      } else if( this.buisnessAlreadyCollect==true){
        this.paymentMethodOptionValue = 4;
        this.tempPaymentMethod = 4;
      }
      // this.paymentMethodOptionValue = 1;
      // this.tax_charges = this.card_tax;
      this.tax_chargesToDisplay = this.card_tax;
    }
    this.reInitializeCalculationArray();
    this.calculating = true;
    setTimeout(() => {
      this.calculateTotalPrice();
      this.calculating = false;
    }, 1000);
  }
  openPaymentListingPopup() {
    this.cardNum = '';
    this.cardName = '';
    this.expiryDate = '';
    this.card_cvv = '';
    $('#expiry').css('border-color', '#ccc');
    // this.getPayementCard();
    // $('#paymentPopup').modal('show');
    $('.jp-card-number').empty();
    $('.jp-card-name').empty();
    $('.jp-card-expiry').empty();
    $('.jp-card-cvc').empty();
    $('.jp-card-number').text('•••• •••• •••• ••••');
    $('.jp-card-name').text('Full Name');
    $('.jp-card-expiry').text('••/••');

    $('#addPaymentPop').modal('show');
  }
  getPayementCard() {

    this.showPaymentView = false;
    console.log('showPaymentView 1', this.showPaymentView);
    // this.nao.go(30);
    this.dataService.getPaymentMethodlist(window.localStorage.getItem('token'), this.customerDisplayDataArray[0].id).subscribe(
      (data) => {
        // this.nao.go(100);
        this.paymentCardData = data;
        this.paymentCardData = this.paymentCardData.Dictionary_Payment_List;

        setTimeout(() => {
          if (this.paymentThroughCash === 'true' && this.paymentThroughCard === 'true') {
            this.paymentMethodOptionValue = -1;
          }
          if (this.paymentThroughCash === 'true' && this.paymentThroughCard === 'false') {
            $('#paymentNoCheck-cash').css('display', 'inline');
            this.paymentMethodOptionValue = 0; 
          }
          console.log(this.paymentThroughCash, this.paymentThroughCard);
          if ((this.paymentThroughCash === 'false' && this.paymentThroughCard === 'true') || this.paymentMethod == 'Online Card') {
            this.paymentMethodOptionValue = 1;
            for (let i = 0; i < this.paymentCardData.length; i++) {
              if (this.paymentCardData[i].primary === true) {
                $('#paymentNoCheck' + i).css('display', 'inline');
              }
            }
            if (this.paymentCardData.length === 0) {
              this.paymentMethodOptionValue = -1;
            }
          }
          this.showPaymentView = true;
          console.log('showPaymentView 2', this.showPaymentView);
        }, 1000);



        // $('.clearPrimary').css('display', 'none');
        // for ( let i = 0; i < this.paymentCardData.length; i++ ) {
        //   if ( this.paymentCardData[i].primary === true ) {
        //     console.log('in primary', i);
        //     $('#paymentNoPrimery' + i).css('display', 'inline-block');
        //   }
        // }
      },
      (error) => {
        // this.nao.go(100);
      }
    );
  }
  removeCardConformPopup(id) {
    this.deleteCardNoId = id;
    $('#removeCardConformPop').modal('show');
  }
  conformRemovefun(id) {
    this.disabledClick = true;
    $('#removeCardConformPop').modal('hide');
    this.dataService.removePaymentMethodOfCustomer(window.localStorage.getItem('token'), id, this.customerDisplayDataArray[0].id).subscribe(
      (data) => {
        this.removeCardData = data;
        if (this.removeCardData.success === false) {
          toastr.error(this.removeCardData.message);
        }
        if (this.removeCardData.success === true) {
          toastr.success(this.removeCardData.message);
        }
        this.disabledClick = false;
        this.getPayementCard();
      },
      (error) => {
        this.disabledClick = false;
      }
    );
  }
  makePaymentMethodPrimaryFunction(id, cardNumber, index) {
    this.customerPrimeryCardNo = cardNumber;
    for (let i = 0; i <= this.paymentCardData.length; i++) {
      $('#primary' + i).prop('checked', false);
    }
    this.nao.go(30);
    this.dataService.makePaymentMethodPrimaryCustomer(window.localStorage.getItem('token'), id, this.customerDisplayDataArray[0].id).subscribe(
      (data) => {
        this.nao.go(100);
        this.primaryDataSuccess = data;
        if (this.primaryDataSuccess.success === true) {
          toastr.success(this.primaryDataSuccess.message);
          $('#primary' + index).prop('checked', true);
        }
      },
      (error) => {
        this.nao.go(100);
        toastr.error('Some thing went wrong');
      }
    );
  }
  openPaymentPop() {
    this.cardNum = '';
    this.cardName = '';
    this.expiryDate = '';
    this.card_cvv = '';
    $('.clr').css('border-color', '#ccc');
    $('.jp-card-number').empty();
    $('.jp-card-name').empty();
    $('.jp-card-expiry').empty();
    $('.jp-card-cvc').empty();
    $('.jp-card-number').text('•••• •••• •••• ••••');
    $('.jp-card-name').text('Full Name');
    $('.jp-card-expiry').text('••/••');
    $('#addPaymentPop').modal('show');
  }

  expiryDateValidation() {
    this.expiryDateError = 0;
    var splitMonth = this.expiryDate.split('/')[0];
    console.log('splitMonth', splitMonth);
    var splitLastWord = this.expiryDate.split('/').splice(-2)[1];
    splitLastWord = this.expiryDate.split(' ').splice(-2)[1];
    // console.log('splitLastWord.length', splitLastWord.length);
    var year = new Date().getFullYear();
    // year = splitLastWord;
    var yearFinal = year.toString();
    console.log('date', year);
    if (splitLastWord.length === undefined) {
      this.expiryDateError++;
      return;
    }
    if (parseInt(splitMonth, 10) > 12) {
      console.log('month invalid');
      this.expiryDateError++;
    }
    if (splitLastWord.length !== undefined) {
      if (splitLastWord.length === 2) {
        var last = yearFinal[yearFinal.length - 1];
        var second = yearFinal[yearFinal.length - 2];
        var final = second + last;
        console.log('in 2', splitLastWord);
        console.log('final', final);
        if (splitLastWord >= final) {
          console.log('date is valid');
          $('#expiry').css('border-color', '#ccc');
        } else {
          console.log('date is not valid');
          // $('#expiry').css('border-color', '#eb3b3b');
          this.expiryDateError++;
        }
      } else if (splitLastWord.length === 4) {
        console.log('in 4 splitLastWord', splitLastWord);
        console.log('in 4 year', yearFinal);
        if (splitLastWord >= yearFinal) {
          console.log('date is valid');
          // $('#expiry').css('border-color', '#ccc');
        } else {
          console.log('date is not valid');
          // $('#expiry').css('border-color', '#eb3b3b');
          this.expiryDateError++;
        }
      } else {
        // $('#expiry').css('border-color', '#eb3b3b');
        this.expiryDateError++;
      }
    } else {
      // $('#expiry').css('border-color', '#eb3b3b');
      this.expiryDateError++;
    }
    if (this.expiryDateError > 0) {
      $('#expiry').css('border-color', '#eb3b3b');
    } else {
      $('#expiry').css('border-color', '#ccc');
    }
  }


  checkCardType(number) {
    // visa
    var re = new RegExp('^4');
    if (number.match(re) != null) {
      // return 'Visa';
      return '4';
    }

    // Mastercard
    // Updated for Mastercard 2017 BINs expansion
    if (/^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(number)) {
      // return 'Mastercard';
      return '5';
    }

    // AMEX
    re = new RegExp('^3[47]');
    if (number.match(re) != null) {
      // return 'AMEX';
      return '2';
    }

    // Discover
    re = new RegExp('^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)');
    if (number.match(re) != null) {
      // return 'Discover';
      return '6';
    }

    // Diners
    re = new RegExp('^36');
    if (number.match(re) != null) {
      // return 'Diners';
      return '7';
    }
    // Diners - Carte Blanche
    re = new RegExp('^30[0-5]');
    if (number.match(re) != null) {
      // return 'Diners - Carte Blanche';
      return '7';
    }

    // JCB
    re = new RegExp('^35(2[89]|[3-8][0-9])');
    if (number.match(re) != null) {
      // return 'JCB';
      return '3';
    }

    // Visa Electron
    re = new RegExp('^(4026|417500|4508|4844|491(3|7))');
    if (number.match(re) != null) {
      // return 'Visa Electron';
      return '4';
    }

    return '0';
  }

  addPaymentMethodFunction() {
    var error_count = 0;
    $('.clr').css('border-color', '#ccc');
    if (this.cardNum === '') {
      $('#number').css('border-color', '#eb3b3b');
      error_count++;
    }
    if (this.cardName === '') {
      $('#name').css('border-color', '#eb3b3b');
      error_count++;
    }
    if (this.expiryDate === '') {
      $('#expiry').css('border-color', '#eb3b3b');
      error_count++;
    }
    if (this.card_cvv === '') {
      $('#cvc').css('border-color', '#eb3b3b');
      error_count++;
    }
    if (error_count > 0) {
      return;
    }
    if (this.expiryDateError > 0) {
      $('#expiry').css('border-color', '#eb3b3b');
      toastr.error('Expiry date is not valid');
      return;
    }
    this.disabledClick = true;
    this.cardType = this.checkCardType(this.cardNum);
    this.nao.go(30);
    this.dataService.addPaymentMethodCustomer(window.localStorage.getItem('token'), this.cardNum, this.cardName, this.expiryDate, this.card_cvv, this.customerDisplayDataArray[0].id, this.cardType).subscribe(
      (data) => {
        this.nao.go(100);
        this.cardSuccess = data;
        this.cardMessage = this.cardSuccess.message;
        this.cardSuccess = this.cardSuccess.success;
        if (this.cardSuccess === true) {
          toastr.success('Card Added Successfully');
          this.cardNum = '';
          this.cardName = '';
          this.expiryDate = '';
          this.card_cvv = '';
          this.getPayementCard();
          $('#addPaymentPop').modal('hide');
        } else {
          toastr.error(this.cardMessage);
        }
        this.disabledClick = false;
      },
      (error) => {
        this.nao.go(100);
        this.disabledClick = false;
        toastr.error('Some thing went wrong');
      }
    );
  }

  selectOutlet(id) {
    this.outletDisplayDataArray = [];
    console.log('outletDataLength', this.outletDataLength);
    for (var i = 0; i < this.outletDataLength; i++) {
      if (this.outletData[i].id === id) {
        this.outletDisplayDataArray.push({
          id: this.outletData[i].id,
          name: this.outletData[i].name,
          email: this.outletData[i].email,
          phone_number: this.outletData[i].country_code + ' ' + this.outletData[i].phone_number,
          address: this.outletData[i].address_line1,
          city: this.outletData[i].city,
          street: this.outletData[i].street,
          state: this.outletData[i].state,
          area: this.outletData[i].area,
          zip: this.outletData[i].zip,
          longitude: this.outletData[i].longitude,
          latitude: this.outletData[i].latitude,
          outlet_type: this.outletData[i].outlet_type
        });
      }
    }
    // this.showmap();
    this.showDistance();
    this.outletSearchBox = false;
    console.log('outlet display data', this.outletDisplayDataArray);
  }
  productCalculation(id, price, quantity, cash_tax, card_tax, index, modifierPrice = 0) {
    console.log('Here are taxes');
    console.log(card_tax, cash_tax);
    console.log(this.productDisplayDataArray);
    console.log(this.productModifierDataArray);
    if (quantity === null) {
      // this.productDisplayDataArray[index].quantityTotal = 1;
      quantity = 0;
    }
    let charges = 0;
    if (this.card_check == true) {
      charges = card_tax;
    }
    if (this.cash_check == true) {
      charges = cash_tax;
    }
    console.log('id', id);

    this.fieldDisable = false;
    clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {

    }, 300);
    setTimeout(() => {
      if (quantity > 0) {
        var obj = {
          id: id,
          total_price: (price + modifierPrice) * quantity,
          tax_charges: charges
        };
        if (this.checkObject(this.calculationArray, obj) === false) {
          this.calculationArray.push(obj);
        } else {

          var objIndex = this.checkValUpdate(this.calculationArray, obj);
          this.calculationArray[objIndex].total_price = this.calculationArray[objIndex].total_price + (price + modifierPrice) * quantity;
          this.calculationArray[objIndex].tax_charges = this.calculationArray[objIndex].tax_charges;
          console.log('this.calculationArray[objIndex].total_price', this.calculationArray[objIndex].total_price);
        }
        console.log('this.calculationArray', this.calculationArray);
        this.calculateTotalPrice();
        // if (this.discount !== 0)
        this.discountFunction();
        this.chargesFunction();

        this.getSlotsDataWithAddress();
      }
    }, 700);
  }
  productCalculationOnOrder(id, price, quantity, index) {
    if (quantity === null) {
      // this.productDisplayDataArray[index].quantityTotal = 1;
      quantity = 0;
    }
    console.log('id', id);
    this.fieldDisable = false;
    // clearTimeout(this.clearTimeout);
    // this.clearTimeout = setTimeout(() => {
    var obj = {
      id: id,
      total_price: price * quantity
    };
    if (this.checkObject(this.calculationArray, obj) === false) {
      this.calculationArray.push(obj);
    } else {
      var objIndex = this.checkValUpdate(this.calculationArray, obj);
      this.calculationArray[objIndex].total_price = price * quantity;
      console.log('this.calculationArray[objIndex].total_price', this.calculationArray[objIndex].total_price);
    }
    console.log('this.calculationArray', this.calculationArray);
    this.calculateTotalPrice();
    // if (this.discount !== 0)
    this.discountFunction();
    this.chargesFunction();
    // }, 300);
    setTimeout(() => {
      if (quantity > 0) {
        this.getSlotsDataWithAddress();
      }
    }, 500);
  }
  preventMinus(e) {
    console.log('e value', e);
    var inputKeyCode = e.keyCode ? e.keyCode : e.which;
    if (inputKeyCode != null) {
      if (inputKeyCode === 45) e.preventDefault();
    }
  }
  updateChargesWhenUpdateDiscount() {
    setTimeout(() => {
      this.getSlotsDataWithAddress();
    }, 700);
  }
  discountFunction() {
    // clearTimeout(this.clearTimeout);
    // this.clearTimeout = setTimeout(() => {
    // if(this.discount === '')this.subTotal = 0;
    this.totalPrice = this.totalPriceDiscount;
    // console.log("totalPrice entry", this.totalPrice);
    var disSubTotal = (this.totalPrice + this.tax_chargesToDisplay - this.mycharges) * this.discount / 100;
    disSubTotal = Math.round(disSubTotal);
    // var disSubTotal1 = this.totalPrice * this.discount / 100;
    // disSubTotal1 = Math.round(disSubTotal1);
    this.subTotal = Math.round(this.totalPrice);
    // this.subTotal = this.totalPrice - disSubTotal - this.mycharges;
    // this.subTotal = Math.round(this.subTotal);
    // this.tax_chargesToDisplay = (this.subTotal * this.tax_charges) / 100;
    // this.tax_chargesToDisplay = Math.round(this.tax_chargesToDisplay);
    this.totalPrice = this.totalPrice - disSubTotal;
    this.totalPrice = Math.round(this.totalPrice);
    this.myTemp = this.totalPrice;
    this.myTemp = Math.round(this.myTemp);
    // console.log("subTotal discountFunction", this.subTotal);
    // console.log("totalPrice discountFunction", this.totalPrice);
    this.chargesFunction();
    // }, 500);
  }
  chargesFunction() {
    if (this.delivery_man_type == 5) {
      this.pickUpCheck = true;
    }
    if (this.pickUpCheck == true) {
      this.charges = 0
    }
    else {

      this.charges = Math.round(this.charges);
    }
    // clearTimeout(this.clearTimeout);
    // this.clearTimeout = setTimeout(() => {
    this.totalPrice = this.myTemp;
    if (this.discount === '' || this.discount === 0) {
      this.totalPrice = this.totalPriceDiscount;
      console.log('if', this.totalPrice);
    }
    else {
      // var temp = this.totalPrice * this.tax_charges / 100;
      // this.totalPrice = this.subTotal + this.mycharges;
      // this.totalPrice = this.totalPriceDiscount;
      // this.totalPrice = this.totalPrice + this.charges;
      console.log('else', this.totalPrice);
    }

    this.totalPrice = this.totalPrice + this.charges;
    console.log('totalPrice chargesFunction', this.totalPrice);
    // }, 500);
  }
  checkObject(array, obj) {
    var value = false;
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === obj.id) {
        value = true;
        break;
      }
    }
    return value;
  }
  checkObjectVariant(array, obj) {

    var value = false;
    var index = -1;
    for (var i = 0; i < array.length; i++) {
      if (array[i].variant_id === obj.variant_id) {
        if (array[i].id === obj.id) {
          value = true;
          index = i;
          break;
        }
      }
    }
    obj = {
      'value': value,
      'index': index
    }
    return obj;
  }
  checkObjectModifier(array, obj) {
    var value = false;
    var index = -1;
    for (var i = 0; i < array.length; i++) {
      if (array[i].variant_id === obj.variant_id) {
        if (array[i].id === obj.id) {
          if (JSON.stringify(array[i].addons) == JSON.stringify(obj.addons) && JSON.stringify(array[i].modifiers) == JSON.stringify(obj.modifiers) && JSON.stringify(array[i].noOption) == JSON.stringify(obj.noOption)) {
            value = true;
            index = i;
            break;
          }
        }
      }
    }
    obj = {
      'value': value,
      'index': index
    }
    return obj;
  }
  checkValUpdate(array, obj) {
    var value = -1;
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === obj.id) {
        value = i;
        break;
      }
    }
    return value;
  }

  checkValUpdateVariant(array, obj) {
    var value = -1;
    for (var i = 0; i < array.length; i++) {
      if (array[i].variant_id === obj.variant_id) {
        value = i;
        break;
      }
    }
    return value;
  }

  checkValUpdateById(array, id) {
    var value = -1;
    for (var i = 0; i < array.length; i++) {
      console.log("array[i].id", array[i].id);
      if (array[i].id === id) {
        value = i;
        break;
      }
    }
    return value;
  }
  calculateTotalPrice() {
    console.log('this.calculationArray', this.calculationArray);
    this.totalPrice = 0;
    this.tax_chargesToDisplay = 0
    for (var i = 0; i < this.calculationArray.length; i++) {
      this.totalPrice = this.totalPrice + this.calculationArray[i].total_price;
      this.tax_chargesToDisplay += this.calculationArray[i].tax_charges * this.calculationArray[i].total_price / 100;
    }
    console.log(this.tax_chargesToDisplay);
    this.totalPrice = Math.round(this.totalPrice);

    this.mycharges = this.totalPrice * this.tax_charges / 100;

    this.mycharges = Math.round(this.mycharges);

    this.totalPriceDiscount = this.totalPrice + this.mycharges;

    this.totalPriceDiscount = Math.round(this.totalPriceDiscount);

  }
  createOrderFunction() {
    if (this.productDisplayDataArray.length === 0) {
      toastr.error('Please select a product');
      return;
    }
    if (this.delivery_man_type == 0 || this.delivery_man_type == undefined) {
      toastr.error('Please select a delivery medium');
      console.log('delivery_man_type', this.delivery_man_type);
      return;
    }

    if (this.paymentMethodOptionValue === -1 && this.tempPaymentMethod === -1) {
      toastr.error('Please select payment method');
      console.log('customerPrimeryCardNo', this.customerPrimeryCardNo);
      return;
    }

    var errorCount = 0;
    for (var j = 0; j < this.productDisplayDataArray.length; j++) {
      this.productDisplayDataArray[j].error_msg = '';
      if (this.productDisplayDataArray[j].quantityTotal === 0 || this.productDisplayDataArray[j].quantityTotal === null || this.productDisplayDataArray[j].quantityTotal === undefined) {
        this.productDisplayDataArray[j].error_msg = 'Please add quantity';
        this.btnDisableOrder = false;
        errorCount++;
      }
    }
    if (errorCount > 0) {
      return;
    }
    this.finalProduct = [];
    // for (var i = 0; i < this.productDisplayDataArray.length; i++) {
    //   this.finalProduct.push({
    //     product_id: this.productDisplayDataArray[i].id,
    //     variant_id: this.productDisplayDataArray[i].variant_id,
    //     quantity: parseInt(this.productDisplayDataArray[i].quantityTotal),
    //   });
    // }
    for (var i = 0; i < this.productDisplayDataArray.length; i++) {
      let modifiers = [];
      if (this.productDisplayDataArray[i].hasModifier === true) {
        for (var j = 0; j < this.productDisplayDataArray[i].modifiers.length; j++) {
          let selectedModifier;
          if (this.productDisplayDataArray[i].modifiers[j].options.price >= 0) {
            selectedModifier = {
              title: this.productDisplayDataArray[i].modifiers[j].title,
              options: {
                title: this.productDisplayDataArray[i].modifiers[j].options.option_name,
                price: this.productDisplayDataArray[i].modifiers[j].options.price
              }
            };
          }
          if (this.productDisplayDataArray[i].modifiers[j].options.option_price >= 0) {
            selectedModifier = {
              title: this.productDisplayDataArray[i].modifiers[j].title,
              options: {
                title: this.productDisplayDataArray[i].modifiers[j].options.option_name,
                price: this.productDisplayDataArray[i].modifiers[j].options.option_price
              }
            };
          }
          modifiers.push(selectedModifier);
        }
        let price = -1;
        if (this.productDisplayDataArray[i].changeCheck && this.productDisplayDataArray[i].changeCheck == 'temporary') {
          price = this.productDisplayDataArray[i].price;
        }
        this.finalProduct.push({
          product_id: this.productDisplayDataArray[i].id,
          variant_id: this.productDisplayDataArray[i].variant_id,
          quantity: parseInt(this.productDisplayDataArray[i].quantityTotal),
          order_detail_id: this.productDisplayDataArray[i].order_detail_id,
          addons: this.productDisplayDataArray[i].addons.options,
          no_options: this.productDisplayDataArray[i].no_options.options,
          modifiers: modifiers,
          variant_updated_price: price,
          updated_variant_description: this.productDisplayDataArray[i].optionValue
        });
      } else {
        let price = -1;
        if (this.productDisplayDataArray[i].changeCheck && this.productDisplayDataArray[i].changeCheck == 'temporary') {
          price = this.productDisplayDataArray[i].price;
        }
        this.finalProduct.push({
          product_id: this.productDisplayDataArray[i].id,
          variant_id: this.productDisplayDataArray[i].variant_id,
          quantity: parseInt(this.productDisplayDataArray[i].quantityTotal),
          order_detail_id: this.productDisplayDataArray[i].order_detail_id,
          variant_updated_price: price,
          updated_variant_description: this.productDisplayDataArray[i].optionValue
        });
      }
    }
    errorCount = 0;
    for (var k = 0; k < this.finalProduct.length; k++) {
      if (this.finalProduct[k].quantity < 1 || this.finalProduct[k].quantity === null || this.finalProduct[k].quantity === undefined) {
        this.productDisplayDataArray[k].error_msg = 'Quantity can not be in negative value';
        this.btnDisableOrder = false;
        errorCount++;
      }
    }
    if (errorCount > 0) {
      return;
    }

    if (this.customerDisplayDataArray.length > 0) {
      if (this.customerDisplayDataArray[0].is_default === false) {
        toastr.error('Please select customer delivery address');
        return;
      }
    } else {
      toastr.error('Please select customer');
      return;
    }

    // for (var i = 0; i < this.customerDisplayDataArray.length; i++) {
    var deliveryAddress = {
      area: this.customerDisplayDataArray[0].street,
      city: this.customerDisplayDataArray[0].city,
      state: this.customerDisplayDataArray[0].state,
      zip: this.customerDisplayDataArray[0].zip,
      latitude: this.customerDisplayDataArray[0].latitude,
      longitude: this.customerDisplayDataArray[0].longitude,
      country: this.customerDisplayDataArray[0].area,
      apart_no: this.customerDisplayDataArray[0].apart_no,
      house_building_no: this.customerDisplayDataArray[0].house_building_no
    };
    // }
    // for (var i = 0; i < this.outletDisplayDataArray.length; i++) {
    var outletAddress = {
      area: this.outletDisplayDataArray[0].street,
      city: this.outletDisplayDataArray[0].city,
      state: this.outletDisplayDataArray[0].state,
      zip: this.outletDisplayDataArray[0].zip,
      country: this.outletDisplayDataArray[0].area,
      latitude: this.outletDisplayDataArray[0].latitude,
      longitude: this.outletDisplayDataArray[0].longitude,
    };
    // }
    this.finalQuantity = this.productDisplayDataArray.length;
    if (this.businessTypeFromSlotRequest === 0) {
      this.time = {};
      if (this.third_party_string === '') {
        toastr.error('Please select your delivery way');
        return;
      }
    }
    if (this.businessTypeFromSlotRequest === 1) {
      if (this.time === undefined || this.time === null) {
        toastr.error('Please select a time slot');
        return;
      }
    }

    if (this.time === null) {
      this.time = {};
    }
    this.nao.go(30);
    // this.paymentMethodOptionValue = 0;
    this.btnDisableOrder = true;
    var dayForTime = new Date();
    var currentSystemTime = new Date(dayForTime).toISOString();

    var todayData = this.todayData;
    if (this.todayData === 0) {
      todayData = 7;
    }
    this.tax_charges = this.tax_chargesToDisplay;
    this.totalPrice += this.tax_chargesToDisplay;
    // if (this.pickUpCheck === true) {
    //   this.dataService.updatePickUpOrder(window.localStorage.getItem('token'),
    //     this.finalProduct, this.notes, this.totalPrice, this.finalQuantity, this.discount,
    //     this.tax_charges, this.timeSlotDetail_delivery_charges_actual, this.customerDisplayDataArray[0].id,
    //     this.customerDisplayDataArray[0].first_name, this.customerDisplayDataArray[0].email,
    //     this.customerDisplayDataArray[0].phone_number, this.outletDisplayDataArray[0].id,
    //     outletAddress, this.subTotal, this.delivery_man_type, this.paymentMethodOptionValue, todayData, this.businessTypeFromSlotRequest, this.time.open_time, this.time.close_time,
    //     this.dayIndex, this.third_party_string, currentSystemTime, this.dispensary_id, this.platform_fee_waive_off).subscribe(
    //       (data) => {
    //         console.log('outlet data');
    //         this.nao.go(100);
    //         this.orderSuccess = data;
    //         this.orderMessage = this.orderSuccess.message;
    //         this.orderStatus = this.orderSuccess.status;
    //         this.orderSuccess = this.orderSuccess.success;
    //         this.createorderResponseUpdate = data;
    //         this.createorderResponse = data;
    //         this.createorderResponse = this.createorderResponse.product;
    //         this.createorderResponseUpdate = this.createorderResponseUpdate.order_update_required;
    //         console.log('this.createorderResponseUpdate', this.createorderResponseUpdate);
    //         if (this.createorderResponseUpdate === true) {
    //           for (var i = 0; i < this.createorderResponse.length; i++) {
    //             if (this.createorderResponse[i].variant_id === this.productDisplayDataArray[i].variant_id) {
    //               if (this.createorderResponse[i].out_of_stock === true) {
    //                 if (this.createorderResponse[i].available_quantity > 0) {
    //                   this.productDisplayDataArray[i].error_msg = '*available quantity' + ' ' + this.createorderResponse[i].available_quantity;
    //                   this.btnDisableOrder = false;
    //                 } else {
    //                   this.productDisplayDataArray[i].error_msg = 'Out of stock';
    //                   this.btnDisableOrder = false;
    //                 }
    //                 console.log('updateError', this.productDisplayDataArray[i].error_msg);
    //               } else {
    //                 this.productDisplayDataArray[i].error_msg = '';
    //               }
    //             }
    //           }
    //         }
    //         if (this.orderSuccess === true) {
    //           toastr.success('Order created successfully');
    //           this.router.navigate(['order-listing']);
    //           this.btnDisableOrder = false;
    //         } else {
    //           if (this.orderStatus === 0) {
    //             this.paymentMethodOptionValue = -1;
    //             this.getBusinessProfile();
    //           }
    //           toastr.error(this.orderMessage);
    //           this.btnDisableOrder = false;
    //         }
    //         this.btnDisableOrder = false;
    //       },
    //       (error) => {
    //         this.nao.go(100);
    //         console.log('error', error);
    //       }
    //     );
    // }
    this.paymentMethodOptionValue = this.tempPaymentMethod;
    this.dataService.updateOrder(window.localStorage.getItem('token'),
      this.finalProduct, this.notes, this.totalPrice, this.finalQuantity, this.discount,
      this.tax_charges, this.charges, this.timeSlotDetail_delivery_charges_actual, this.customerDisplayDataArray[0].id,
      this.customerDisplayDataArray[0].first_name, this.customerDisplayDataArray[0].email,
      this.customerDisplayDataArray[0].phone_number, this.outletDisplayDataArray[0].id,
      outletAddress, deliveryAddress, this.subTotal, this.delivery_man_type, this.paymentMethodOptionValue, todayData, this.businessTypeFromSlotRequest, this.time.open_time, this.time.close_time,
      this.dayIndex, this.third_party_string, this.id, this.showBreakdownIcon, currentSystemTime, this.dispensary_id, this.platform_fee_waive_off).subscribe(
        (data) => {
          console.log('outlet data');
          this.nao.go(100);
          this.orderSuccess = data;
          this.orderMessage = this.orderSuccess.message;
          this.orderStatus = this.orderSuccess.status;
          this.orderSuccess = this.orderSuccess.success;
          this.createorderResponseUpdate = data;
          this.createorderResponse = data;
          this.createorderResponse = this.createorderResponse.product;
          this.createorderResponseUpdate = this.createorderResponseUpdate.order_update_required;
          console.log('this.createorderResponseUpdate', this.createorderResponseUpdate);
          if (this.createorderResponseUpdate === true) {
            for (var i = 0; i < this.createorderResponse.length; i++) {
              if (this.createorderResponse[i].variant_id === this.productDisplayDataArray[i].variant_id) {
                if (this.createorderResponse[i].out_of_stock === true) {
                  if (this.createorderResponse[i].available_quantity > 0) {
                    this.productDisplayDataArray[i].error_msg = '*available quantity' + ' ' + this.createorderResponse[i].available_quantity;
                    this.btnDisableOrder = false;
                  } else {
                    this.productDisplayDataArray[i].error_msg = 'Out of stock';
                    this.btnDisableOrder = false;
                  }
                  console.log('updateError', this.productDisplayDataArray[i].error_msg);
                } else {
                  this.productDisplayDataArray[i].error_msg = '';
                }
              }
            }
          }
          if (this.orderSuccess === true) {
            toastr.success('Order updated successfully');
            this.router.navigate(['/order-listing']);
            this.btnDisableOrder = false;
          } else {
            if (this.orderStatus === 0) {

              this.paymentMethodOptionValue = -1;
              this.getBusinessProfile();
            }
            toastr.error(this.orderMessage);
            this.btnDisableOrder = false;
          }
          this.btnDisableOrder = false;
        },
        (error) => {
          this.nao.go(100);
          console.log('error', error);
        }
      );
  }
  closeCustomerDetailBox() {
    this.freeCount = 0;
    this.CustomerSearchBox = true;
    this.editAddress = false;
    this.customerDisplayDataArray = [];
    this.closeOutletDetailBox();
    this.timeSlotDetail_delivery_charges = 0;
    this.platformFeeData.delivery_charges = this.timeSlotDetail_delivery_charges;

    if (this.pickUpCheck == true) {
      this.charges = 0;
    }
    else {
      this.charges = this.platformFeeData.delivery_charges + this.platformFeeData.platform_fee;
    }
    this.discountFunction();
    // this.showmap();
    this.showDistance();
    $('.CustomerSearchBoxHide').css('display', 'none');
    $('.CustomerSearchBoxShow').css('display', 'block');
    $('.editAddressHide').css('display', 'none');
    $('.editAddressShow').css('display', 'block');

    setTimeout(() => {
      this.slotSuccessMessage = '';
      this.timeSlotDetail_delivery = [];
      var emptyArray = [];
      this.timeSlotDetail_delivery_show = JSON.parse(JSON.stringify(emptyArray));
      this.dayOfGivenTime = '';
      this.overnight = '';
      this.timeSlotDetail = null;
      this.dayIndex = null;
      this.outletIdToSendInCheckout = null;
      this.third_party_string = '';
      this.time = null;
      this.businessTypeFromSlotRequest = null;
      this.timeSlotDetail_delivery_charges = 0;
      this.platformFeeData.delivery_charges = this.timeSlotDetail_delivery_charges;

      this.charges = this.platformFeeData.delivery_charges + this.platformFeeData.platform_fee;
      this.discountFunction();

    }, 500);

  }
  closeOutletDetailBox() {
    this.outletDisplayDataArray = [];
    this.outletSearchBox = true;
    // this.showmap();
    this.showDistance();
  }
  // Customer add code
  findCustomer() {
    this.nao.go(30);
    var getCode = $('#phone').intlTelInput('getSelectedCountryData').dialCode;
    var num = '+' + getCode + this.number;
    console.log('login data');
    this.dataService.showCustomerList(window.localStorage.getItem('token'), num).subscribe(
      (data) => {
        this.nao.go(100);
        this.findCustomerData = data;
        if (this.findCustomerData.rest_error_code === 4) {
          // toastr.error('Customer does not exist');
          this.customerMatch = false;
          $('#datepicker').val('');
          this.first_name = '';
          this.last_name = '';
          this.accept_marketing = false;
          this.is_tax_exempt = false;
          this.email = '';
          this.note = '';
          this.findCustomerData = '';
          this.address_line1 = '';
          this.address_line2 = '';
          this.city = '';
          this.state = '';
          this.zip = '';
          this.area = '';
          $('#is_tax_exempt').prop('checked', false);
          $('#accept_marketing').prop('checked', false);
          this.selectAddress = false;
          return;
        } else {
          this.dob = '';
          this.selDate = '';
          setTimeout(() => {
            // this.findCustomerData = data;
            // $('#datepicker').val(this.findCustomerData.date_of_birth);
            this.dob = this.findCustomerData.date_of_birth;
            this.selDate = this.findCustomerData.date_of_birth;
            this.first_name = this.findCustomerData.first_name;
            this.last_name = this.findCustomerData.last_name;
            this.accept_marketing = this.findCustomerData.accept_marketing;
            this.is_tax_exempt = this.findCustomerData.tax_exempt;
            this.email = this.findCustomerData.email;
            this.note = this.findCustomerData.note;
            this.findCustomerData = this.findCustomerData.address;
            this.latitude = this.findCustomerData.latitude;
            this.longitude = this.findCustomerData.longitude;
            this.address_line1 = this.findCustomerData.address_line1;
            this.address_line2 = this.findCustomerData.address_line2;
            this.city = this.findCustomerData.city;
            this.state = this.findCustomerData.state;
            this.street = this.findCustomerData.street;
            this.zip = this.findCustomerData.zip;
            this.area = this.findCustomerData.area;
            this.apart = this.findCustomerData.apart_no;
            if (this.is_tax_exempt === true) {
              $('#is_tax_exempt').prop('checked', true);
            }
            if (this.accept_marketing === true) {
              $('#accept_marketing').prop('checked', true);
            }
            this.customerMatch = true;
            console.log('cutomer data get with phone#', data);
            if (this.findCustomerData.longitude !== null && this.findCustomerData.longitude !== '' && this.findCustomerData.latitude !== null && this.findCustomerData.latitude !== '' && this.findCustomerData.address_line1 !== null && this.findCustomerData.address_line1 !== '') {
              this.selectAddress = true;
              this.callMap();
            } else {
              this.selectAddress = false;
            }
          }, 1000);
        }

      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  prefindCustomerForDisplayData(number) {
    this.nao.go(30);
    console.log('showCustomerListById', number);
    this.dataService.showCustomerListById(window.localStorage.getItem('token'), number).subscribe(
      (data) => {
        this.nao.go(100);
        this.prefilledCustomerData = data;
        this.customerDisplayDataArray = [];
        if (this.prefilledCustomerData.country_code === '+1') {
          this.prefilledCustomerData.phone_number = format(this.prefilledCustomerData.phone_number, 'US', 'NATIONAL');
          console.log('this.prefilledCustomerData.number', this.prefilledCustomerData.phone_number);
        }

        this.selectedCustomerId = this.prefilledCustomerData.id;
        this.selectedCustomerObj = this.prefilledCustomerData;
        this.customerAddressList = this.prefilledCustomerData.address_list.address_dictionary;
        this.customerDisplayDataArray.push({
          id: this.prefilledCustomerData.id,
          first_name: this.prefilledCustomerData.first_name,
          last_name: this.prefilledCustomerData.last_name,
          payments: this.prefilledCustomerData.payments,
          email: this.prefilledCustomerData.email,
          country_code: this.prefilledCustomerData.country_code,
          phone_number: this.prefilledCustomerData.phone_number,
          address: '',
          street: '',
          city: '',
          state: '',
          area: '',
          zip: '',
          apart_no: '',
          longitude: 0,
          latitude: 0,
          is_default: false,
          place_label: false,
          address_id: null
        });
        for (var j = 0; j < this.prefilledCustomerData.address_list.address_dictionary.length; j++) {
          if (this.prefilledCustomerData.address_list.address_dictionary[j].is_default === true) {
            this.customerDisplayDataArray = [];
            this.customerDisplayDataArray.push({
              id: this.prefilledCustomerData.id,
              first_name: this.prefilledCustomerData.first_name,
              last_name: this.prefilledCustomerData.last_name,
              payments: this.prefilledCustomerData.payments,
              email: this.prefilledCustomerData.email,
              country_code: this.prefilledCustomerData.country_code,
              phone_number: this.prefilledCustomerData.phone_number,
              address: this.prefilledCustomerData.address_list.address_dictionary[j].address_line1,
              street: this.prefilledCustomerData.address_list.address_dictionary[j].address_line1,
              city: this.prefilledCustomerData.address_list.address_dictionary[j].city,
              state: this.prefilledCustomerData.address_list.address_dictionary[j].state,
              area: this.prefilledCustomerData.address_list.address_dictionary[j].country,
              zip: this.prefilledCustomerData.address_list.address_dictionary[j].zip,
              apart_no: this.prefilledCustomerData.address_list.address_dictionary[j].apart_no,
              longitude: this.selectedCustomerObj.address_list.address_dictionary[j].longitude,
              latitude: this.selectedCustomerObj.address_list.address_dictionary[j].latitude,
              is_default: this.prefilledCustomerData.address_list.address_dictionary[j].is_default,
              house_building_no: this.prefilledCustomerData.address_list.address_dictionary[j].house_building_no,
              place_label: this.prefilledCustomerData.address_list.address_dictionary[j].place_label,
              address_id: this.prefilledCustomerData.address_list.address_dictionary[j].id
            });
            if (this.outletData) {
              // this.showmap();
              this.showDistance;
            }
          }
        }

        this.getPayementCard();
        if (this.productDisplayDataArray.length > 0) {
          this.getSlotsDataWithAddress();
        }
        setTimeout(() => {
          $('.CustomerSearchBoxHide').css('display', 'block');
          $('.CustomerSearchBoxShow').css('display', 'none');
        }, 500);
        // $('#paymentNoCheck-cash').css('display', 'none');
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  openAddCustomerPop() {
    this.customerMatch = false;
    $('#datepicker').val('');
    this.first_name = '';
    this.last_name = '';
    this.accept_marketing = false;
    this.is_tax_exempt = false;
    this.email = '';
    this.note = '';
    this.findCustomerData = '';
    this.number = '';
    this.address_line1 = '';
    this.address_line2 = '';
    this.city = '';
    this.state = '';
    this.street = '';
    this.zip = '';
    this.area = '';
    this.apart = '';
    // $('#city').val('');
    // $('#zip').val('');
    // $('#state').val('');
    // $('#area').val('');
    // $('#apart').val('');
    $('#is_tax_exempt').prop('checked', false);
    $('#accept_marketing').prop('checked', false);
    $('#addCustomerPop').modal('show');
    $('.c-label label').css('color', '#3d3e3d');
    $('.uploadText').css('color', '#3d3e3d');
    $('.c-label input').css('border-color', '#ccc');
    $('.c-label textarea').css('border-color', '#ccc');
    this.selectAddress = false;
  }
  addCutomerFunction() {
    this.error_count = 0;
    $('.c-label label').css('color', '#3d3e3d');
    $('.uploadText').css('color', '#3d3e3d');
    $('.c-label input').css('border-color', '#ccc');
    $('.c-label textarea').css('border-color', '#ccc');
    this.addingCustomer = true;
    if ($('#is_tax_exempt').is(':checked')) {
      this.is_tax_exempt = true;
    }
    if ($('#accept_marketing').is(':checked')) {
      this.accept_marketing = true;
    }
    this.address_line1 = $('#searchTextFieldAddAddress').val();
    this.city = $('#city').val();
    this.zip = $('#zip').val();
    this.state = $('#state').val();
    this.area = $('#area').val();
    this.apart = $('#apart').val();
    this.houseNo = $('#houseNo').val();

    // this.dob = $('#datepicker').val();
    var formatedDob = this.dob.formatted;
    this.address_line1 = $('#searchTextFieldAddAddress').val();
    console.log('login data', this.address_line1);
    if (this.first_name === '' || this.first_name === undefined) {
      $('#c-fname label').css('color', '#a10a0d');
      $('#c-fname input').css('border-color', '#a10a0d');
      this.error_count++;
    }
    if (this.last_name === '' || this.last_name === undefined) {
      $('#c-lname label').css('color', '#a10a0d');
      $('#c-lname input').css('border-color', '#a10a0d');
      this.error_count++;
    }
    if (this.number === '' || this.number === undefined || this.numChk === true) {
      $('#c-phone label').css('color', '#a10a0d');
      $('#c-phone input').css('border-color', '#a10a0d');
      this.error_count++;
    }
    // if (this.dob === '' || this.dob === undefined) {
    //             $('#c-dob label').css('color', '#a10a0d');
    //             $('#c-dob input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    // this.emailChk = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    // if (!this.emailChk.test(this.email) && this.email !== '') {
    //             $('#c-email label').css('color', '#a10a0d');
    //             $('#c-email input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    if (this.address_line1 === '' || this.address_line1 === undefined) {
      $('#c-address label').css('color', '#a10a0d');
      $('#c-address input').css('border-color', '#a10a0d');
      this.error_count++;
    }
    // if (this.address_line2 === '' || this.address_line2 === undefined) {
    //             $('#c-address2 label').css('color', '#a10a0d');
    //             $('#c-address2 input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    if (this.city === '' || this.city === undefined) {
      $('#c-city label').css('color', '#a10a0d');
      $('#c-city input').css('border-color', '#a10a0d');
      this.error_count++;
    }
    if (this.zip === '' || this.zip === undefined) {
      $('#c-zip label').css('color', '#a10a0d');
      $('#c-zip input').css('border-color', '#a10a0d');
      this.error_count++;
    }
    if (this.state === '' || this.state === undefined) {
      $('#c-state label').css('color', '#a10a0d');
      $('#c-state input').css('border-color', '#a10a0d');
      this.error_count++;
    }
    if (this.area === '' || this.area === undefined) {
      $('#c-area label').css('color', '#a10a0d');
      $('#c-area input').css('border-color', '#a10a0d');
      this.error_count++;
    }

    if (this.gender === '' || this.gender === -1) {
      $('#c-gender label').css('color', '#a10a0d');
      $('#c-gender input').css('border-color', '#a10a0d');
      this.error_count++;
    }
    // if (this.note === '' || this.note === undefined) {
    //             $('#c-note label').css('color', '#a10a0d');
    //             $('#c-note input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    if (this.error_count > 0) {
      return;
    }
    if (this.latitude === undefined || this.latitude === '' || this.longitude === undefined || this.longitude === '') {
      toastr.error('Please Update the address & select it from Google suggestions for accuracy');
      return;
    }
    var getCode = $('#phone').intlTelInput('getSelectedCountryData').dialCode;
    var number = '+' + getCode + this.number;
    console.log('number', this.number);
    this.nao.go(30);
    this.btnDisable = true;
    this.street = this.address_line1;
    this.dataService.addCustomer(window.localStorage.getItem('token'),
      this.first_name, this.last_name, number,
      this.email, this.is_tax_exempt, this.accept_marketing,
      this.address_line1, this.street, this.address_line2, this.city,
      this.state, this.zip, this.area, this.apart, this.note, formatedDob, this.latitude, this.longitude, this.houseNo, this.gender,'').subscribe(
        (data) => {
          console.log('outlet data');
          this.nao.go(100);
          this.success = data;
          this.restErrorCode = data;
          this.restErrorCode = this.restErrorCode.rest_error_code;
          // this.success = this.success.success;
          if (this.restErrorCode === 1) {
            toastr.error('Some thing went wrong');
            this.btnDisable = false;
          }
          if (this.restErrorCode === 2) {
            toastr.error('Please login again');
            this.btnDisable = false;
          }
          if (this.restErrorCode === 3) {
            toastr.error('Customer already exists');
            this.btnDisable = false;
          }
          if (this.restErrorCode === 4) {
            toastr.error('Customer does not exist');
            this.btnDisable = false;
          }
          if (this.success.success === true) {
            this.btnDisable = false;
            $('#addCustomerPop').modal('hide');
            // var getCode = $('#phone').intlTelInput('getSelectedCountryData').dialCode;
            // var number = '+' + getCode + this.number;
            var number = this.success.customer_id;
            console.log('in success of add customer', number, this.success);
            this.prefindCustomerForDisplayData(number);
            // this.searchStringCustomer = this.first_name;
            // $('#cText').focus();
            // this.searchCustomerOnOrder();
          }
          if (this.success.success === false) {
            this.addingCustomer = false;
            this.btnDisable = false;
          }
        },
        (error) => {
          this.nao.go(100);
          this.addingCustomer = false;
          this.btnDisable = false;
          console.log('error', error);
        }
      );
  }
  addressDetailAddCustomer() {
    this.street = '';
    console.log('chk address detail', this.place);
    for (var i = 0; i < this.placeDetailData.length; i++) {
      for (var j = 0; j < this.placeDetailData[i].types.length; j++) {
        // if (this.placeDetailData[i].types[j] === 'administrative_area_level_2') {
        //   // this.city = this.placeDetailData[i].long_name;
        //   // console.log('city', this.city);
        //    $('#city').val(this.placeDetailData[i].long_name);
        // }
        if (this.placeDetailData[i].types[j] === 'locality') {
          // this.city = this.placeDetailData[i].long_name;
          // console.log('city', this.city);
          $('#city').val(this.placeDetailData[i].long_name);
        }
        if (this.placeDetailData[i].types[j] === 'street_number') {
          this.street = this.placeDetailData[i].long_name;
          console.log('street number', this.street);
        }
        if (this.placeDetailData[i].types[j] === 'route') {
          this.street = this.street + ' ' + this.placeDetailData[i].long_name;
          console.log('route', this.street);
        }
        if (this.placeDetailData[i].types[j] === 'sublocality_level_2') {
          this.street = this.street + ' ' + this.placeDetailData[i].long_name;
          console.log('sublocality 2', this.street);
        }
        if (this.placeDetailData[i].types[j] === 'sublocality_level_1') {
          this.street = this.street + ' ' + this.placeDetailData[i].long_name;
          console.log('sublocality 1', this.street);
        }

        if (this.placeDetailData[i].types[j] === 'administrative_area_level_1') {
          // this.state = this.placeDetailData[i].long_name;
          $('#state').val(this.placeDetailData[i].short_name);
        }

        if (this.placeDetailData[i].types[j] === 'country') {
          // this.area = this.placeDetailData[i].long_name;
          $('#area').val(this.placeDetailData[i].long_name);
        }

        if (this.placeDetailData[i].types[j] === 'postal_code') {
          // this.zip = this.placeDetailData[i].long_name;
          console.log('postal; code', this.placeDetailData[i].long_name);
          $('#zip').val(this.placeDetailData[i].long_name);
        } else {
          $('#zip').val('');
        }
        // this.latitude = this.place.geometry.location.lat();
        // this.longitude = this.place.geometry.location.lng();

      }
    }
  }
  // inputAddress2() {
  // const input2 = document.getElementById('searchTextField2');
  // const searchBox2 = new google.maps.places.Autocomplete(input2);
  // searchBox2.addListener('place_changed', function() {
  //
  //   console.log('place changed');
  //   // const place = searchBox2.getPlace();
  //   // console.log('address', place);
  // });
  // }
  addressDetailEdit() {
    var context = this;
    // const input3 = document.getElementById('findPlaceOnOrder');
    // const searchBox3 = new google.maps.places.Autocomplete(input3);
    // searchBox3.addListener('place_changed', function() {

    // console.log('place changed');
    //   context.placeForEditAddress = searchBox3.getPlace();
    console.log('address', context.placeForEditAddress);
    for (var i = 0; i < context.placeDetailData2.length; i++) {
      for (var j = 0; j < context.placeDetailData2[i].types.length; j++) {
        // if (context.placeDetailData2[i].types[j] === 'administrative_area_level_2') {
        //   // this.city = this.placeDetailData[i].long_name;
        //   // console.log('city', this.city);
        //    $('#city2').val(context.placeDetailData2[i].long_name);
        // }
        if (context.placeDetailData2[i].types[j] === 'locality') {
          // this.city = this.placeDetailData[i].long_name;
          // console.log('city', this.city);
          $('#city2').val(context.placeDetailData2[i].long_name);
        }

        if (context.placeDetailData2[i].types[j] === 'street_number') {
          context.street3 = context.placeDetailData2[i].long_name;
          console.log('street number', context.street3);
        }
        if (context.placeDetailData2[i].types[j] === 'route') {
          context.street3 = context.street3 + ' ' + context.placeDetailData2[i].long_name;
          console.log('route', context.street3);
        }
        if (context.placeDetailData2[i].types[j] === 'sublocality_level_2') {
          context.street3 = context.street3 + ' ' + context.placeDetailData2[i].long_name;
          console.log('sublocality 2', this.street);
        }
        if (context.placeDetailData2[i].types[j] === 'sublocality_level_1') {
          context.street3 = context.street3 + ' ' + context.placeDetailData2[i].long_name;
          console.log('sublocality 1', context.street3);
        }

        if (context.placeDetailData2[i].types[j] === 'administrative_area_level_1') {
          // this.state = this.placeDetailData[i].long_name;
          $('#state2').val(context.placeDetailData2[i].short_name);
        }

        if (context.placeDetailData2[i].types[j] === 'country') {
          // this.area = this.placeDetailData[i].long_name;
          $('#area2').val(context.placeDetailData2[i].long_name);
        }

        if (context.placeDetailData2[i].types[j] === 'postal_code') {
          // this.zip = this.placeDetailData[i].long_name;
          console.log('postal; code', context.placeDetailData2[i].long_name);
          $('#zip2').val(context.placeDetailData2[i].long_name);
        } else {
          $('#zip2').val('');
        }
        // context.latitude2 = context.placeForEditAddress.geometry.location.lat();
        // context.longitude2 = context.placeForEditAddress.geometry.location.lng();

      }
    }
    // });
  }
  // inputAddress1() {
  //   console.log('inputAddress');
  //   var context = this;
  //   const input = document.getElementById('searchTextField');
  //
  //   const searchBox = new google.maps.places.Autocomplete(input);
  //   searchBox.addListener('place_changed', function() {
  //
  //     console.log('place changed');
  //     context.place = searchBox.getPlace();
  //     console.log('address', context.place);
  //     context.addressDetailOrder();
  //   });
  // }
  functionTogetPlace() {
    if (this.selectAddress === true) {
      return;
    }
    this.placeDataFound = false;
    this.placeSuggestionsData = [];
    clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
      // this.addressLoad = true;
      this.dataService.googleAddress(this.address_line1).subscribe(
        (data) => {
          this.placeSuggestionsData = data;
          this.placeSuggestionsData = this.placeSuggestionsData.predictions;
          // console.log('place google data', this.placeSuggestionsData);
          this.placeDataFound = true;
          if ($('.myDrop').hasClass('open')) {

          } else {
            $('.myDrop').addClass('open');
          }
          // this.addressLoad = false;
          // $('#searchTextField').click();
          // $('#searchTextField').focus();
        },
        (error) => {
        }
      );
    }, 1000);
  }
  functionTogetPlaceDetail(name, id) {
    this.addressLoad = true;
    this.address_line1 = name;
    clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
      this.dataService.googleAddressDetail(id).subscribe(
        (data) => {
          // console.log('place google detail data', data);
          this.placeDetailData = data;
          this.selectAddress = true;
          this.placeDetailData = this.placeDetailData.result;
          this.latitude = this.placeDetailData.geometry.location.lat;
          this.longitude = this.placeDetailData.geometry.location.lng;
          // console.log('this.latitude', this.latitude);
          // console.log('this.longitude', this.longitude);
          this.placeDetailData = this.placeDetailData.address_components;
          setTimeout(() => {
            this.callMap();
            this.addressDetailAddCustomer();
            this.addressLoad = false;
          }, 1000);
        },
        (error) => {
        }
      );
    }, 1000);
  }
  resetAddress() {
    this.address_line1 = '';
    // this.address_line2 = '';
    this.city = '';
    this.state = '';
    this.zip = '';
    this.area = '';
    this.apart = '';
    this.longitude = '';
    this.latitude = '';
    this.houseNo = '';
    this.selectAddress = false;
  }
  callMap() {
    setTimeout(() => {
      $('#myMapDiv').css('display', 'block');
      var context = this;
      var map;
      var marker;
      var adr;
      var myLatlng = new google.maps.LatLng(this.latitude, this.longitude);
      var geocoder = new google.maps.Geocoder();
      var infowindow = new google.maps.InfoWindow();
      var mapOptions = {
        zoom: 14,
        center: myLatlng,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        navigationControl: false,
        // mapTypeControl: false,
        // disableDefaultUI: true
      };
      var endImage = {
        url: 'assets/pin.png', // url
        scaledSize: new google.maps.Size(50, 56), // scaled size
        origin: new google.maps.Point(0, 0), // origin
        anchor: new google.maps.Point(16, 16) // anchor
      };
      map = new google.maps.Map(document.getElementById('myMap'), mapOptions);
      marker = new google.maps.Marker({
        map: map,
        position: myLatlng,
        draggable: true,
        icon: endImage,
      });
      geocoder.geocode({ 'latLng': myLatlng }, function (results, status) {
        if (status === google.maps.GeocoderStatus.OK) {
          if (results[0]) {
            // $('#address').val(results[0].formatted_address);
            // $('#latitude').val(marker.getPosition().lat());
            // $('#longitude').val(marker.getPosition().lng());
            infowindow.setContent(results[0].formatted_address);
            infowindow.open(map, marker);
            context.latitude = marker.getPosition().lat();
            context.longitude = marker.getPosition().lng();
            console.log(context.latitude, context.longitude);
            console.log('results', results);
            // context.getDeliveryAddressDetail(results[0]);

          }
        }
      });


      google.maps.event.addListener(marker, 'dragend', function () {
        geocoder.geocode({ 'latLng': marker.getPosition() }, function (results, status) {
          if (status === google.maps.GeocoderStatus.OK) {
            if (results[0]) {
              infowindow.setContent(results[0].formatted_address);
              infowindow.open(map, marker);
              context.latitude = marker.getPosition().lat();
              context.longitude = marker.getPosition().lng();
              // context.addressNew =  results[0].formatted_address;
              console.log(context.latitude, context.longitude);
              console.log('results', results);
              // this.changeRef.detectChanges();
              // context.getDeliveryAddressDetail(results[0]);
            }
          }
        });
      });
    }, 500);
  }
  // for edit address
  functionTogetPlace2() {
    if (this.selectAddressCustomer === true) {
      return;
    }
    this.placeDataFound2 = false;
    this.placeSuggestionsData2 = [];
    clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
      // this.addressLoad = true;
      this.dataService.googleAddress(this.address).subscribe(
        (data) => {
          this.placeSuggestionsData2 = data;
          this.placeSuggestionsData2 = this.placeSuggestionsData2.predictions;
          // console.log('place google data', this.placeSuggestionsData);
          this.placeDataFound2 = true;
          if ($('.myDrop').hasClass('open')) {

          } else {
            $('.myDrop').addClass('open');
          }
          // this.addressLoad = false;
          // $('#searchTextField').click();
          // $('#searchTextField').focus();
        },
        (error) => {
        }
      );
    }, 1000);
  }
  functionTogetPlaceDetail2(name, id) {
    this.addressLoad2 = true;
    // this.address_line1 = name;
    this.address = name;
    clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
      this.dataService.googleAddressDetail(id).subscribe(
        (data) => {
          // console.log('place google detail data', data);
          this.placeDetailData2 = data;
          this.selectAddressCustomer = true;
          $('.selectAddressCustomerEdit').css('display', 'block');
          this.placeDetailData2 = this.placeDetailData2.result;
          this.latitude2 = this.placeDetailData2.geometry.location.lat;
          this.longitude2 = this.placeDetailData2.geometry.location.lng;
          // console.log('this.latitude', this.latitude);
          // console.log('this.longitude', this.longitude);
          this.placeDetailData2 = this.placeDetailData2.address_components;
          this.callMapCustomer();
          setTimeout(() => {
            this.addressDetailEdit();
            this.addressLoad2 = false;
          }, 1000);
        },
        (error) => {
        }
      );
    }, 1000);
  }


  restrictUserInput($event) {
    $event.preventDefault();
  }
  editAddressFunnc(address) {
    if (this.customerDisplayDataArray[0].is_default === false) {
      this.selectAddressCustomerFun(address);
      return;
    }
    console.log('adddrees', address)
    console.log('customerDisplayDataArray', this.customerDisplayDataArray);
    this.selectAddressCustomer = true;
    // this.editAddress = true;
    $('.editAddressHide').css('display', 'block');
    $('.editAddressShow').css('display', 'none');
    $('.selectAddressCustomerEdit').css('display', 'block');
    $('#findPlaceOnOrder').val('');
    this.placeLabelDefault = address.place_label;
    $('#city2').val(address.city);
    $('#state2').val(address.state);
    $('#area2').val(address.country);
    $('#zip2').val(address.zip);
    $('#editHouseNo').val(address.house_building_no);
    $('#apart_no').val(address.apart_no);
    $('#findPlaceOnOrder').val(address.address_line1);
    // $('#findPlaceOnOrder').val(this.customerDisplayDataArray[0].street);
    console.log('street', address.address_line1);
    this.placeSuggestionsData2 = [];
    this.editAddressId = address.id;
    // this.address = this.customerDisplayDataArray[0].street;
    this.street3 = '';
    this.longitude2 = address.longitude;
    this.latitude2 = address.latitude;
    this.callMapCustomer();
  }
  editAddressFunncClose() {
    // this.editAddress = false;
    $('.editAddressHide').css('display', 'none');
    $('.editAddressShow').css('display', 'block');
  }
  editAddressDone() {
    console.log('val chk', this.latitude2, this.longitude2);
    if ($('#findPlaceOnOrder').val() === '' || $('#city2').val() === '' ||
      $('#state2').val() === '' || $('#area2').val() === '' || $('#zip2').val() === '') {
      toastr.error('Please fill all address fields');
      return;
    }

    this.customerDisplayDataArray[0].address = $('#findPlaceOnOrder').val();
    this.customerDisplayDataArray[0].city = $('#city2').val();
    this.customerDisplayDataArray[0].state = $('#state2').val();
    this.customerDisplayDataArray[0].area = $('#area2').val();
    this.customerDisplayDataArray[0].zip = $('#zip2').val();
    this.customerDisplayDataArray[0].house_building_no = $('#editHouseNo').val();
    this.customerDisplayDataArray[0].apart_no = $('#apart_no').val();
    // this.customerDisplayDataArray[0].street = this.street3;
    this.customerDisplayDataArray[0].street = $('#findPlaceOnOrder').val();
    this.customerDisplayDataArray[0].longitude = this.longitude2;
    this.customerDisplayDataArray[0].latitude = this.latitude2;
    this.customerDisplayDataArray[0].place_label = this.placeLabelDefault;

    // this.showmap();
    this.showDistance();
    this.dataService.editCustomerAddresss(window.localStorage.getItem('token'), this.customerDisplayDataArray[0].address, this.customerDisplayDataArray[0].street, this.customerDisplayDataArray[0].city,
      this.customerDisplayDataArray[0].state, this.customerDisplayDataArray[0].zip, this.customerDisplayDataArray[0].area, this.customerDisplayDataArray[0].apart_no, this.customerDisplayDataArray[0].id, this.customerDisplayDataArray[0].latitude, this.customerDisplayDataArray[0].longitude, this.customerDisplayDataArray[0].place_label, this.editAddressId, this.customerDisplayDataArray[0].house_building_no).subscribe(
        (data) => {
          var number = this.selectedCustomerObj.id;
          // var number =  this.selectedCustomerObj.country_code + this.selectedCustomerObj.phone_number;
          // number = number.replace('(', '');
          // number = number.replace(')', '');
          // number = number.replace('-', '');
          // number = number.replace(/\s/g, '');
          this.prefindCustomerForDisplayData(number);
          $('.editAddressHide').css('display', 'none');
          $('.editAddressShow').css('display', 'block');
        },
        (error) => {
          console.log('error', error);
        }
      );

  }
  callMapCustomer() {
    var context = this;
    var map;
    var marker;
    var adr;
    var myLatlng = new google.maps.LatLng(this.latitude2, this.longitude2);
    var geocoder = new google.maps.Geocoder();
    var infowindow = new google.maps.InfoWindow();
    var mapOptions = {
      zoom: 18,
      center: myLatlng,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      navigationControl: false,
      // mapTypeControl: false,
      // disableDefaultUI: true
    };
    var endImage = {
      url: 'assets/pin.png', // url
      scaledSize: new google.maps.Size(30, 42), // scaled size
      origin: new google.maps.Point(0, 0), // origin
      anchor: new google.maps.Point(16, 41) // anchor
    };
    map = new google.maps.Map(document.getElementById('customerMap'), mapOptions);
    marker = new google.maps.Marker({
      map: map,
      position: myLatlng,
      draggable: true,
      icon: endImage,
    });
    geocoder.geocode({ 'latLng': myLatlng }, function (results, status) {
      if (status === google.maps.GeocoderStatus.OK) {
        if (results[0]) {
          infowindow.setContent(results[0].formatted_address);
          infowindow.open(map, marker);
          context.latitude2 = marker.getPosition().lat();
          context.longitude2 = marker.getPosition().lng();
          console.log(context.latitude2, context.longitude2);
          console.log('results', results);
        }
      }
    });


    google.maps.event.addListener(marker, 'dragend', function () {
      geocoder.geocode({ 'latLng': marker.getPosition() }, function (results, status) {
        if (status === google.maps.GeocoderStatus.OK) {
          if (results[0]) {
            infowindow.setContent(results[0].formatted_address);
            infowindow.open(map, marker);
            context.latitude2 = marker.getPosition().lat();
            context.longitude2 = marker.getPosition().lng();
            console.log(context.latitude2, context.longitude2);
            console.log('results', results);
          }
        }
      });
    });
  }
  resetAddressCustomer() {
    $('#findPlaceOnOrder').val('');
    $('#city2').val('');
    $('#state2').val('');
    $('#area2').val('');
    $('#editHouseNo').val('');
    this.editHouseNo = '';
    $('#zip2').val('');
    $('#apart_no').val('');
    $('.selectAddressCustomerEdit').css('display', 'none');
    this.selectAddressCustomer = false;
  }
  countryValidation() {
    var code = $('#phone').intlTelInput('getSelectedCountryData').dialCode;
    code = '+' + code;
    var val = $('#phoneValue').val();
    for (var i = 0; i < this.cs.country.length; i++) {
      if (code === this.cs.country[i].countryCode) {
        console.log('val.length', val.length, this.cs.country[i].length);
        if (val.length === this.cs.country[i].length) {
          console.log('valid');
          this.numChk = false;
          $('#phoneValue').css('border-color', '#ccc');
        } else {
          console.log('invalid');
          this.numChk = true;
          $('#phoneValue').css('border-color', '#eb3b3b');
        }
      }
    }
  }
  prevent($event) {
    // console.log('prevent default', $event.keyCode);
    if ($event.keyCode === 8 || $event.keyCode === 46) {
      return;
    }
    if (!($event.keyCode >= 48 && $event.keyCode <= 57)) {
      $event.preventDefault();
      return;
    }
  }
  preventMaxVal($event) {
    // var a = $('#discount').val();
    this.discount = parseInt(this.discount);
    console.log('a', this.discount);
    if (this.discount >= 10) {
      // this.discount = 100;
      console.log('value great', this.discount);
      $event.preventDefault();
      // return;
    }
  }
  getPlatformFeeFunction() {
    // this.nao.go(30);

    this.dataService.getPlatformChargesForFee(window.localStorage.getItem('token'), this.dispensary_id).subscribe(
      (data) => {
        // this.nao.go(100);
        this.platformFeeData = data;
        this.platformFeeData = this.platformFeeData.charges;
        // this.totalPrice  = this.platformFeeData.total_charges;
        this.tax_charges = Math.round(this.platformFeeData.tax_rate);
        this.platformFeeData.delivery_charges = Math.round(this.timeSlotDetail_delivery_charges);

        if (this.pickUpCheck == true) {
          this.charges = 0;
        }
        else {
          this.charges = this.platformFeeData.delivery_charges + this.platformFeeData.platform_fee;
        }
        this.charges = Math.round(this.charges);
        this.totalPrice = this.charges;
        // this.tax_chargesToDisplay = this.platformFeeData.tax_rate;
        // this.platform_charges = this.platformFeeData.delivery_charges;
      },
      (error) => {
        // this.nao.go(100);
      }
    );
  }
  getBusinessProfile() {
    console.log('showPaymentViewfirst', this.showPaymentView);
    this.dataService.businessProfile(window.localStorage.getItem('token'), this.dispensary_id).subscribe(
      (data) => {
        // this.nao.go(100);
        this.businessProfileData = data;
        if (this.businessProfileData.payment_through_cash === true) {
          this.paymentThroughCash = 'true';
        } else {
          this.paymentThroughCash = 'false';
        }
        if (this.businessProfileData.payment_through_card === true) {
          this.paymentThroughCard = 'true';
        } else {
          this.paymentThroughCard = 'false';
        }
        if (this.businessProfileData.payment_through_bank_transfer === true) {
          this.paymentThroughBankTransfer = 'true';
        } else {
          this.paymentThroughBankTransfer = 'false';
        }
        if (this.businessProfileData.payment_through_mpos === true) {
          this.paymentThroughMpos = 'true';
        } else {
          this.paymentThroughMpos = 'false';
        }




        setTimeout(() => {
          // if (this.paymentThroughCash === 'true' && this.paymentThroughCard === 'true') {
          //   this.paymentMethodOptionValue = -1;
          // }
          // if (this.paymentThroughCash === 'true' && this.paymentThroughCard === 'false') {
          //   $('#paymentNoCheck-1').css('display', 'inline');
          //   this.paymentMethodOptionValue = 0;
          // }
          // console.log(this.paymentThroughCash, this.paymentThroughCard);
          // if (this.paymentThroughCash === 'false' && this.paymentThroughCard === 'true') {
          //   this.paymentMethodOptionValue = 1;
          //   for (let i = 0; i < this.paymentCardData.length; i++) {
          //     if (this.paymentCardData[i].primary === true) {
          //       $('#paymentNoCheck' + i).css('display', 'inline');
          //     }
          //   }
          //   if (this.paymentCardData.length === 0) {
          //     this.paymentMethodOptionValue = -1;
          //   }
          // }

          if (this.paymentThroughCash === 'true' && this.paymentThroughCard === 'true' && this.paymentThroughBankTransfer === 'true' && this.paymentThroughMpos === 'true') {
            this.paymentMethodOptionValue = -1;
          }
          if (this.paymentThroughCash === 'true' && this.paymentThroughCard === 'false' && this.paymentThroughBankTransfer === 'false' && this.paymentThroughMpos === 'false') {
            $('#paymentNoCheck-1').css('display', 'inline');
            this.cash_check = true;
            this.card_check = false;
            this.paymentMethodOptionValue = 0;
          }
          if (this.paymentThroughCash === 'false' && this.paymentThroughCard === 'true' && this.paymentThroughBankTransfer === 'false' && this.paymentThroughMpos === 'false') {
            this.paymentMethodOptionValue = 1;
            for (let i = 0; i < this.paymentCardData.length; i++) {
              if (this.paymentCardData[i].primary === true) {
                $('#paymentNoCheck' + i).css('display', 'inline');
                this.card_check = true;
                this.cash_check = false;
              }
            }
            if (this.paymentCardData.length === 0) {
              this.paymentMethodOptionValue = -1;
            }
          }
          if (this.paymentThroughCash === 'false' && this.paymentThroughCard === 'false' && this.paymentThroughBankTransfer === 'true' && this.paymentThroughMpos === 'false') {
            this.card_check = true;
            this.cash_check = false;
            this.paymentMethodOptionValue = 2;
          }
          if (this.paymentThroughCash === 'false' && this.paymentThroughCard === 'false' && this.paymentThroughBankTransfer === 'false' && this.paymentThroughMpos === 'true') {
            this.card_check = true;
            this.cash_check = false;
            this.paymentMethodOptionValue = 3;
          }
        }, 2000);

        // this.paymentThroughCash = 'false';
        // this.paymentThroughCard = 'false';
        // this.paymentThroughCash = window.localStorage.getItem('paymentThroughCash');
        // this.paymentThroughCard = window.localStorage.getItem('paymentThroughCard');
      },
      (error) => {
        // this.nao.go(100);
      }
    );
  }
  openSetLabelPopup() {
    this.placeLabelError = '';
    this.CustomeplaceLabel = '';
    if (this.placeLabelDefault === 'Work' || this.placeLabelDefault === 'Home') {
      this.placeLabel = this.placeLabelDefault;
    } else {
      this.CustomeplaceLabel = this.placeLabelDefault;
    }
    $('#labelPopup').modal('show');
  }
  setLabel(label) {
    if (label === 'Home') {
      this.placeLabel = 'Home';
    }
    if (label === 'Work') {
      this.placeLabel = 'Work';
    }
    this.placeLabelError = '';
    this.CustomeplaceLabel = '';
  }
  customeLabelDone() {
    if (this.CustomeplaceLabel === 'Work' || this.CustomeplaceLabel === 'Home') {
      return;
    }
    this.placeLabelDefault = this.placeLabel;
    $('#labelPopup').modal('hide');
  }
  changeSetLabel(value) {
    this.placeLabelError = '';
    if (value === 'Work') {
      // this.CustomeplaceLabel = '';
      this.placeLabel = '';
      this.placeLabelError = 'Please select Work from above';
      return;
    }
    if (value === 'Home') {
      // this.CustomeplaceLabel = '';
      this.placeLabel = '';
      this.placeLabelError = 'Please select Home from above';
      return;
    }
    if (value === '') {
      this.CustomeplaceLabel = '';
      this.placeLabel = 'Home';
      return;
    }
    if (value !== 'Home' && value !== 'Work') {
      this.placeLabel = value;
      return;
    }
  }
  capitlizeAddressLabel() {
    this.CustomeplaceLabel = this.CustomeplaceLabel.replace(/\b\w/g, function (l) { return l.toUpperCase(); });
  }
  addNewAddressCustomer(customerId) {
    this.events.publish('AddAddressCustomerId', customerId);
    $('.AddNewAddressCustomerMain').css('display', 'block');
    $('.createOrderPageMain').css('display', 'none');
  }
  getSlotsDataWithAddress() {
    console.log('customerDisplayDataArray slot', this.customerDisplayDataArray);
    if (this.productDisplayDataArray.length === 0) {
      return;
    }
    if (this.customerDisplayDataArray.length === 0) {
      return;
    }
    if (this.customerDisplayDataArray[0].latitude === 0 && this.customerDisplayDataArray[0].longitude === 0) {
      return;
    }
    console.log('in customer address chek', this.customerDisplayDataArray);
    this.slotSuccessMessage = '';
    this.timeSlotDetail_delivery = [];
    var emptyArray = [];
    this.timeSlotDetail_delivery_show = JSON.parse(JSON.stringify(emptyArray));
    this.dayOfGivenTime = '';
    this.overnight = '';
    this.timeSlotDetail = null;
    this.dayIndex = null;
    this.outletIdToSendInCheckout = null;
    this.third_party_string = '';
    this.time = null;
    var productListForSlot = new Array();
    for (var i = 0; i < this.productDisplayDataArray.length; i++) {
      var obj = {
        product_id: this.productDisplayDataArray[i].id,
        variant_id: this.productDisplayDataArray[i].variant_id,
        quantity: this.productDisplayDataArray[i].quantityTotal
      };
      productListForSlot.push(obj);
    }
    for (var j = 0; j < this.productDisplayDataArray.length; j++) {
      this.productDisplayDataArray[j].error_msg = '';
    }
    // this.delivery_man_type = 0;

    var dayForTime = new Date();
    var currentSystemTime = new Date(dayForTime).toISOString();
    this.breakdownCharges = 0;
    this.breakdownChargesDis = 0;
    this.breakdownChargesTotal = 0;
    this.showBreakdownIcon = false;

    var todayData = this.todayData;
    if (this.todayData === 0) {
      todayData = 7;
    }
    this.dispensary_id;
    this.dataService.getSlotsListWithAddress(window.localStorage.getItem('token'), todayData, this.customerDisplayDataArray[0], productListForSlot, currentSystemTime, this.customerDisplayDataArray[0].id, this.subTotal, this.dispensary_id).subscribe(
      (data) => {
        $('#slotDefault').prop("checked", false);
        $('#slotCustom').prop("checked", false);
        this.createorderResponseUpdate = data;
        this.slotSuccess = this.createorderResponseUpdate;
        this.charges = this.slotSuccess.detail_dictionary.delivery_rate_charges;
        if (this.slotSuccess.success === false) {
          if (this.slotSuccess.message === 'We cannot deliver in your area yet' || this.slotSuccess.message === 'We can not deliver in your area yet') {
            this.slotSuccessMessage = this.slotSuccess.message_with_business;
            toastr.error(this.slotSuccessMessage);
            this.businessTypeFromSlotRequest = null;
            this.outletSearchBox = true;
            return;
          }
        }
        this.createorderResponse = data;
        this.createorderResponse = this.createorderResponse.product;
        this.createorderResponseUpdate = this.createorderResponseUpdate.order_update_required;
        console.log('this.createorderResponseUpdate', this.createorderResponseUpdate);
        if (this.createorderResponseUpdate === true) {
          for (var i = 0; i < this.createorderResponse.length; i++) {
            if (this.createorderResponse[i].variant_id === this.productDisplayDataArray[i].variant_id) {
              if (this.createorderResponse[i].out_of_stock === true) {
                if (this.createorderResponse[i].available_quantity > 0) {
                  this.productDisplayDataArray[i].error_msg = '*available quantity' + ' ' + this.createorderResponse[i].available_quantity;
                  this.btnDisableOrder = false;
                } else {
                  this.productDisplayDataArray[i].error_msg = 'Out of stock';
                  this.btnDisableOrder = false;
                }
                console.log('updateError', this.productDisplayDataArray[i].error_msg);
              } else {
                this.productDisplayDataArray[i].error_msg = '';
              }
            }
          }
        }


        emptyArray = [];
        this.timeSlotDetail_delivery_show = JSON.parse(JSON.stringify(emptyArray));
        this.timeSlotDetail = data;
        this.timeSlotDetailOrignal = data;
        this.outletIdToSendInCheckout = this.timeSlotDetail.outlet_id;
        this.timeSlotDetail = this.timeSlotDetail.detail_dictionary;
        this.timeSlotDetailOrignal = this.timeSlotDetailOrignal.detail_dictionary;
        this.over_night_charges = Math.round(this.timeSlotDetail.over_night_charges);
        this.days_charges = Math.round(this.timeSlotDetail.days_charges);
        this.timeSlotDetail_delivery = this.timeSlotDetail.delivery_slot_list;
        this.businessTypeFromSlotRequest = this.timeSlotDetail.business_type;
        this.timeSlotDetail_delivery_charges = Math.round(this.timeSlotDetail.delivery_rate_charges);
        this.timeSlotDetail_delivery_charges_actual = Math.round(this.timeSlotDetail.delivery_rate_charges_calculated);
        console.log('timeSlotDetail_delivery', this.timeSlotDetail_delivery);
        this.business_type = this.timeSlotDetail.business_type;
        var slotsArray = this.timeSlotDetail_delivery;
        for (var i = 0; i < slotsArray.length; i++) {
          if (slotsArray[i].slots.length > 0) {
            this.timeSlotDetail_delivery_show.push(slotsArray[i]);
          }
        }
        for (var i = 0; i < this.timeSlotDetail_delivery_show.length; i++) {
          for (var j = 0; j < this.timeSlotDetail_delivery_show[i].slots.length; j++) {
            var cDate = new Date().getDate();
            var cYear = new Date().getFullYear();
            var cMonth = new Date().getUTCMonth() + 1;
            var openTime = this.timeSlotDetail_delivery_show[i].slots[j].open_time;
            var tOpen = cYear + '/' + cMonth + '/' + cDate + ' ' + openTime + ' ' + 'UTC';
            var dateObjOpen = new Date(tOpen);
            this.timeSlotDetail_delivery_show[i].slots[j].open_time = dateObjOpen;

            var closeTime = this.timeSlotDetail_delivery_show[i].slots[j].close_time;
            var tClose = cYear + '/' + cMonth + '/' + cDate + ' ' + closeTime + ' ' + 'UTC';
            var dateObjClose = new Date(tClose);
            this.timeSlotDetail_delivery_show[i].slots[j].close_time = dateObjClose;
          }
        }
        if (this.businessTypeFromSlotRequest === 1) {
          this.showBreakdownIcon = this.timeSlotDetailOrignal.off_price_subscribed_checked;
          this.breakdownCharges = this.timeSlotDetail.delivery_rate_charges_calculated;
          this.breakdownChargesDis = this.timeSlotDetail.off_price_subscribed;
          this.breakdownChargesTotal = this.timeSlotDetailOrignal.delivery_rate_charges;


          this.platformFeeData.delivery_charges = this.timeSlotDetail_delivery_charges;

          // if (this.tempCharges == true) {
          //   this.charges = 0;
          // }
          // else {
          //   this.charges = this.platformFeeData.delivery_charges + this.platformFeeData.platform_fee;
          // }
       
          this.discountFunction();
        }
        if (this.businessTypeFromSlotRequest === 0) {
          this.breakdownChargesDis = this.timeSlotDetail.off_price_subscribed;

          this.timeSlotDetail_delivery_charges = 0;
          this.platformFeeData.delivery_charges = this.timeSlotDetail_delivery_charges;

          this.charges = this.platformFeeData.delivery_charges + this.platformFeeData.platform_fee;
          this.discountFunction();
        }

        console.log('this.timeSlotDetail_delivery_show', this.timeSlotDetail_delivery_show);

        this.selectOutlet(this.outletIdToSendInCheckout);
      },
      (error) => {
      }
    );
  }
  addDayAndTime(day, dayIndex, time, index) {
    console.log('index', index);
    if (time.is_available === false) {
      toastr.error('This slot is not available');
      return;
    }
    $('.clearSlotSelection').removeClass('selectedSlot');
    setTimeout(() => {
      $('#selectedSlot' + index).addClass('selectedSlot');
    }, 100);
    this.dayOfGivenTime = day;
    this.dayIndex = dayIndex;
    console.log('day', this.dayOfGivenTime);
    console.log('this.dayIndex', this.dayIndex);
    this.time = time;
    console.log('day', this.time);

  }


  OvernightFunction(type) {
    if (type === 'night') {
      this.breakdownCharges = this.timeSlotDetailOrignal.over_night_charges_calculated;
      this.breakdownChargesTotal = this.timeSlotDetailOrignal.over_night_charges;
      if (this.isFreeDelivery === true) {
        this.overnight = 'Overnight';
      } else {
        this.overnight = 'Overnight(Rs. ' + this.over_night_charges + ')';
      }
      this.third_party_string = 'Overnight';
      this.timeSlotDetail_delivery_charges = this.over_night_charges;
      this.platformFeeData.delivery_charges = this.timeSlotDetail_delivery_charges;
      this.charges = this.platformFeeData.delivery_charges + this.platformFeeData.platform_fee;
      this.discountFunction();
      // console.log('Day charges', this.charges);
    }
    if (type === 'day') {
      this.breakdownCharges = this.timeSlotDetailOrignal.days_charges_calculated;
      this.breakdownChargesTotal = this.timeSlotDetailOrignal.days_charges;
      if (this.isFreeDelivery === true) {
        this.overnight = '3-5 Business Days';
      } else {
        this.overnight = '3-5 Business Days(Rs. ' + this.days_charges + ')';
      }

      this.third_party_string = '3-5 Business Days';
      this.timeSlotDetail_delivery_charges = this.days_charges;
      this.platformFeeData.delivery_charges = this.timeSlotDetail_delivery_charges;

      this.charges = this.platformFeeData.delivery_charges + this.platformFeeData.platform_fee;
      this.discountFunction();
    }
    this.showBreakdownIcon = this.timeSlotDetailOrignal.off_price_subscribed_checked;
  }


  clear_values() {
    this.time = null;
    this.timeSlotDetail_delivery_show = [];
    // this.time.open_time = '';
    // this.time.close_time = '';
    this.dayOfGivenTime = '';
    this.overnight = '';
    this.timeSlotDetail = null;
    this.dayIndex = null;
    this.outletIdToSendInCheckout = null;
    this.third_party_string = '';
  }

  orderDetailCall() {
    this.dataService.getOrderhDetail(window.localStorage.getItem('token'), this.id).subscribe(
      (data) => {
        this.orderDetailData = data;
        this.customerDetail = this.orderDetailData.customer_detail;
        this.droppOffAddress = this.orderDetailData.dropoff_address;
        this.orderDataDisplay = this.orderDetailData.order;
        this.isFreeDelivery = this.orderDataDisplay.is_free_delivery;
        console.log('this.isFreeDelivery', this.isFreeDelivery);
        this.delivery_charges = this.orderDataDisplay.business_fee;
        if (this.delivery_charges == 0) {
          this.tempCharges = true;
        }
        else {
          this.tempCharges = false;
        }
        this.charges = this.orderDataDisplay.deliver_charges;
        // console.log('this.deliverCharges', this.deliverCharges);
        this.pickupAddress = this.orderDetailData.pickup_address;
        this.OrderproductData = this.orderDetailData.product;
        window.localStorage.setItem('client_id', this.customerDetail.id);
        this.delivery_man_type = this.orderDataDisplay.delivery_man_type;
        this.paymentMethod = this.orderDataDisplay.payment_method;
        if (this.paymentMethod == 'C.O.D') {
          $('#paymentNoCheck-cash').css('display', 'inline-block');
          this.cash_check = true;
          this.tempPaymentMethod = 0;
        }
        if (this.paymentMethod == 'Online Card') {
          this.tempPaymentMethod = 1;
          this.card_check=true;
        }

        if (this.paymentMethod == 'Bank Transfer') {
          $('#paymentNoCheck-bank').css('display', 'inline-block');
          this.card_check = true;
          this.bank_check = true;
          this.tempPaymentMethod = 2;
        } if (this.paymentMethod == 'MPOS') {
          $('#paymentNoCheck-mpos').css('display', 'inline-block');
          this.card_check = true;
          this.mos_check = true;
          this.tempPaymentMethod = 3;
        } if ( this.paymentMethod == 'Already Paid to Business'){
          $('#paymentNoCheck-alreadyPaid').css('display', 'inline-block');
          this.card_check = true;
          this.mos_check = false;
          this.buisnessAlreadyCollect=true;
          this.tempPaymentMethod = 4;
        }
        for (var i = 0; i < this.OrderproductData.length; i++) {
          //this.OrderproductData
          let hasModifier = false;
          if (this.OrderproductData[i].modifiers.length > 0 || (this.OrderproductData[i].addons != null && this.OrderproductData[i].addons.options != null && this.OrderproductData[i].addons.options.length > 0) || (this.OrderproductData[i].no_options != null && this.OrderproductData[i].no_options.options != null && this.OrderproductData[i].no_options.options.length > 0)) {
            hasModifier = true;
          }
          // let tax_value;
          // if (this.OrderproductData[i].implemented_tax != undefined) {
          //   tax_value = this.OrderproductData[i].implemented_tax;
          // }
          // else {
          //   tax_value = 0;
          // }
          var obj = {
            quantityTotal: this.OrderproductData[i].quantity,
            id: this.OrderproductData[i].product_id,
            name: this.OrderproductData[i].product_name,
            order_detail_id: this.OrderproductData[i].order_detail_id,
            image: this.OrderproductData[i].img_url,
            variantName: this.OrderproductData[i].variant_name,
            optionValue: this.OrderproductData[i].variant_description,
            inventory_count: 100,
            cash_tax: this.OrderproductData[i].cash_tax_percentage,
            card_tax: this.OrderproductData[i].card_tax_percentage,
            price: Math.round(this.OrderproductData[i].unit_price),
            compare_price: Math.round(this.OrderproductData[i].sale_price),
            is_on_sale: this.OrderproductData[i].is_on_sale,
            variant_id: this.OrderproductData[i].variant_id,
            modifiers: this.OrderproductData[i].modifiers,
            addons: this.OrderproductData[i].addons,
            no_options: this.OrderproductData[i].no_options,
            hasModifier: hasModifier,
            modifier_price_calculation: this.OrderproductData[i].modifier_price_calculation,
            modifier_price_calculation_single: this.OrderproductData[i].modifier_price_calculation / this.OrderproductData[i].quantity,
            error_msg: ''
          };
          // if (this.checkObjectVariant(this.productDisplayDataArray, obj) === false) {
          this.productDisplayDataArray.push(obj);
          // }
          // const index = this.checkValUpdateVariant(this.productDisplayDataArray,obj);
          const index = this.productDisplayDataArray.indexOf(obj);

          this.productCalculation(this.productDisplayDataArray[index].variant_id, this.productDisplayDataArray[index].price, this.productDisplayDataArray[index].quantityTotal, this.productDisplayDataArray[index].cash_tax, this.productDisplayDataArray[index].card_tax, index, this.productDisplayDataArray[index].modifier_price_calculation_single);
        }

        this.thirdPartyData = this.orderDetailData.third_party;
        this.onDetailDriverData = this.orderDetailData.driver;
        this.discount = this.orderDataDisplay.discount;
        this.notes = this.orderDataDisplay.notes;
        this.setSearchProductOnOrder();

        var number = this.customerDetail.id;
        this.prefindCustomerForDisplayData(number);

        // this.customerDisplayDataArray = [];
        //     this.customerDisplayDataArray.push({
        //       id: this.customerDetail.id,
        //       first_name: this.customerDetail.first_name,
        //       last_name: this.customerDetail.last_name,
        //       payments: this.customerDetail.payments,
        //       email: this.customerDetail.email,
        //       country_code: this.customerDetail.country_code,
        //       phone_number: this.customerDetail.phone_number,
        //       address: this.customerDetail.address.address_line1,
        //       street: this.customerDetail.address.street,
        //       city: this.customerDetail.address.city,
        //       state: this.customerDetail.address.state,
        //       area: this.customerDetail.address.area,
        //       zip: this.customerDetail.address.zip,
        //       apart_no: this.customerDetail.address.apart_no,
        //       longitude: this.customerDetail.address.longitude,
        //       latitude: this.customerDetail.address.latitude
        //     });
        //     $('.CustomerSearchBoxHide').css('display', 'block');
        //     $('.CustomerSearchBoxShow').css('display', 'none');
        //     $('#paymentNoCheck-1').css('display', 'none');
        this.chRef.detectChanges();

        this.dispensary_id;
        clearTimeout(this.clearTimeout);
        this.clearTimeout = setTimeout(() => {
          console.log('login data');
          this.dataService.searchOutletsList(window.localStorage.getItem('token'), this.searchStringOutlet, this.dispensary_id).subscribe(
            (data) => {
              this.outletData = data;
              this.outletNationWide = this.outletData.is_nation_wide;
              this.outletData = this.outletData.items;
              this.outletDataLength = this.outletData.length;
              for (var i = 0; i < this.outletData.length; i++) {
                if (this.outletData[i].country_code === '+1') {
                  this.outletData[i].phone_number = format(this.outletData[i].phone_number, 'US', 'NATIONAL');
                  console.log('this.driverData[i].number', this.outletData[i].phone_number);
                }
              }
              this.outletDisplayDataArray = [];
              for (var j = 0; j < this.outletData.length; j++) {
                if (this.outletData[j].name === this.pickupAddress.dispensary_name) {
                  this.outletDisplayDataArray.push({
                    id: this.outletData[j].id,
                    name: this.outletData[j].name,
                    email: this.outletData[j].email,
                    phone_number: this.outletData[j].country_code + ' ' + this.outletData[j].phone_number,
                    address: this.outletData[j].address_line1,
                    city: this.outletData[j].city,
                    street: this.outletData[j].street,
                    state: this.outletData[j].state,
                    area: this.outletData[j].area,
                    zip: this.outletData[j].zip,
                    longitude: this.outletData[j].longitude,
                    latitude: this.outletData[j].latitude,
                    outlet_type: this.outletData[j].outlet_type
                  });
                }
              }
              this.outletSearchBox = false;
              // this.showmap();
              this.showDistance();
              // this.getPayementCard();
            },
            (error) => {
              console.log('error', error);
            }
          );
        }, 1000);


      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  showDistance() {
    this.final_answer = this.getDistance();
    this.final_answer = this.final_answer / 1000;
    console.log(this.final_answer);
  }
  rad(x) {
    return x * Math.PI / 180;
  };

  getDistance() {

    let latitude;
    let longitutde;
    let secondLat;
    let secondLong;
    if (this.outletDisplayDataArray.length > 0) {

      latitude = this.outletDisplayDataArray[0].latitude;
      longitutde = this.outletDisplayDataArray[0].longitude;
    } else {
      latitude = this.outletData[0].latitude;
      longitutde = this.outletData[0].longitude;
    }
    if (this.customerDisplayDataArray.length > 0) {
      secondLat = this.customerDisplayDataArray[0].latitude;
      secondLong = this.customerDisplayDataArray[0].longitude;
    }
    var R = 6378137; // Earth’s mean radius in meter
    var dLat = this.rad(secondLat - latitude);
    var dLong = this.rad(secondLong - longitutde);
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.rad(secondLat)) * Math.cos(this.rad(latitude)) *
      Math.sin(dLong / 2) * Math.sin(dLong / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d; // returns the distance in meter
  }
  openVariantModifiersPop(variantId, hasModifier, ind) {
    console.log(hasModifier);
    if (hasModifier === true) {
      this.dataService.getVariantDetail(window.localStorage.getItem('token'), variantId).subscribe(
        res => {
          let checkModifier = false;
          let obj;
          if (this.OrderproductData[ind].modifiers.length > 0 || (this.OrderproductData[ind].addons != null && this.OrderproductData[ind].addons.options != null && this.OrderproductData[ind].addons.options.length > 0) || (this.OrderproductData[ind].no_options != null && this.OrderproductData[ind].no_options.options != null && this.OrderproductData[ind].no_options.options.length > 0)) {
            checkModifier = true;
            obj = {
              quantityTotal: this.OrderproductData[ind].quantity,
              id: this.OrderproductData[ind].product_id,
              name: this.OrderproductData[ind].product_name,
              image: this.OrderproductData[ind].img_url,
              variantName: this.OrderproductData[ind].variant_name,
              order_detail_id: this.OrderproductData[ind].order_detail_id,
              optionValue: this.OrderproductData[ind].variant_description,
              inventory_count: 100,
              cash_tax: this.OrderproductData[ind].cash_tax_percentage,
              card_tax: this.OrderproductData[ind].card_tax_percentage,
              price: Math.round(this.OrderproductData[ind].unit_price),
              compare_price: Math.round(this.OrderproductData[ind].sale_price),
              is_on_sale: this.OrderproductData[ind].is_on_sale,
              variant_id: variantId,
              modifiers: res['modifiers'],
              addons: res['addons'],
              noOption: res['no_options'],
              hasModifier: checkModifier,
              error_msg: ''
            };
          }
          let modPrices = 0;
          res['modifiers'].forEach(modElement => {
            for (let i = 0; i < 1; i++) {
              modPrices += modElement.options[0].price;
            }
          });
          let totalNoOptionPrice = 0;
          for (let j = 0; j < res['no_options'].options.length; j++) {
            totalNoOptionPrice = totalNoOptionPrice + res['no_options'].options[j].price;
            this.noOptionsPrice = totalNoOptionPrice;
          }
          this.addItValue = Math.round(this.OrderproductData[ind].unit_price) + totalNoOptionPrice + modPrices;
          this.actualPrice = Math.round(this.OrderproductData[ind].unit_price);

          // console.log(this.productDisplayDataArray);
          // const index = this.checkValUpdateVariant(this.productDisplayDataArray,obj);
          // this.productCalculation(this.productDisplayDataArray[index].variant_id, this.productDisplayDataArray[index].price, this.productDisplayDataArray[index].quantityTotal, index);
          this.productModifierDataArray = new Array;
          this.productModifierDataArray.push(obj);
          console.log(this.productModifierDataArray);
          this.ind = ind;
          for (let i = 0; i < this.productModifierDataArray[0].modifiers.length; i++) {
            for (let j = 0; j < 1; j++) {
              this.productModifierDataArray[0].modifiers[i].options[j].selected = true;
              this.modifiersArr.push({
                groupTitle: this.productModifierDataArray[0].modifiers[i].title,
                optionTitle: this.productModifierDataArray[0].modifiers[i].options[j].title,
                optionPrice: this.productModifierDataArray[0].modifiers[i].options[j].price
              });
            }
          }
        },
        err => console.log(err)
      );
      $('#addVariantsModifiersPop').modal('show');
    }
  }

  closeModal() {
    this.productData = [];
    this.addonsArr = [];
    this.noOptionsArr = [];
    this.modifiersArr = [];
    this.addItValue = 0;
    this.priceAddon = 0;
    this.actualPrice = 0;
    this.noOptionsPrice = 0;
    if (this.addonsArr.length > 0) {
      for (let i = 0; i < this.addonsArr.length; i++) {
        this.addonsArr[i].price = 0;
      }
    }
    for (let i = 0; i < this.productModifierDataArray[0].modifiers.length; i++) {
      for (let j = 0; j < this.productModifierDataArray[0].modifiers[i].options.length; j++) {
        if (this.productModifierDataArray[0].modifiers[i].options[j].selected == true) {
          this.productModifierDataArray[0].modifiers[i].options[j].price = 0;
          this.addItValue = 0;
        }
      }
    }
  }

  plusModifierValue(groupId, optionId) {
    this.priceAddon = 0;
    if (this.addonsArr.length > 0) {
      for (let i = 0; i < this.addonsArr.length; i++) {
        this.priceAddon = this.priceAddon + this.addonsArr[i].price;
      }
    }
    if (this.noOptionsPrice !== undefined) {
      this.addItValue = this.actualPrice + this.noOptionsPrice + this.priceAddon;
    }
    else {
      this.addItValue = this.actualPrice + this.priceAddon;

    }
    this.modifiersArr = [];
    for (let i = 0; i < this.productModifierDataArray[0].modifiers.length; i++) {
      if (this.productModifierDataArray[0].modifiers[i].id == groupId) {
        for (let j = 0; j < this.productModifierDataArray[0].modifiers[i].options.length; j++) {
          if (this.productModifierDataArray[0].modifiers[i].options[j].id == optionId) {
            this.productModifierDataArray[0].modifiers[i].options[j].selected = true;
          } else {
            this.productModifierDataArray[0].modifiers[i].options[j].selected = false;
          }
        }
      }
    }
    for (let i = 0; i < this.productModifierDataArray[0].modifiers.length; i++) {
      for (let j = 0; j < this.productModifierDataArray[0].modifiers[i].options.length; j++) {
        if (this.productModifierDataArray[0].modifiers[i].options[j].selected == true) {
          this.addItValue = this.addItValue + this.productModifierDataArray[0].modifiers[i].options[j].price;
          this.modifiersArr.push({
            groupTitle: this.productModifierDataArray[0].modifiers[i].title,
            optionTitle: this.productModifierDataArray[0].modifiers[i].options[j].title,
            optionPrice: this.productModifierDataArray[0].modifiers[i].options[j].price
          });
        }
      }
    }
    console.log(this.modifiersArr);
  }

  plusAddonsValue(value, title, event) {
    if (event.target.checked === true) {
      this.addItValue = this.addItValue + value;
      this.addonsArr.push({
        title: title,
        price: value
      });
    } else if (event.target.checked === false) {
      this.addItValue = this.addItValue - value;
      for (var i = 0; i <= this.addonsArr.length - 1; i++) {
        if (this.addonsArr[i]['title'] == title) {
          this.addonsArr.splice(i, 1);
        }
      }
    }
    console.log(this.addonsArr);
  }

  subNoOptionValue(value, title, event) {
    if (event.target.checked === true) {
      for (var i = 0; i <= this.noOptionsArr.length - 1; i++) {
        if (this.noOptionsArr[i]['title'] == title) {
          this.noOptionsArr.splice(i, 1);
        }
      }
      this.addItValue = this.addItValue + value;
    } else if (event.target.checked === false) {
      this.noOptionsArr.push({
        title: title,
        price: value
      });
      this.addItValue = this.addItValue - value;
    }
    console.log(this.noOptionsArr);
  }

  addItFunction(price, i) {

    let modifiers = [];
    let addons = { options: [] };
    let noOptions = { options: [] };
    for (var j = 0; j < this.modifiersArr.length; j++) {
      let selectedModifier = {
        title: this.modifiersArr[j].groupTitle,
        options: {
          option_name: this.modifiersArr[j].optionTitle,
          price: this.modifiersArr[j].optionPrice
        }
      };
      modifiers.push(selectedModifier);
    }
    for (var j = 0; j < this.addonsArr.length; j++) {
      let selectedModifier = {
        title: this.addonsArr[j].title,
        price: this.addonsArr[j].price
      };
      addons.options.push(selectedModifier);
    }
    for (var j = 0; j < this.noOptionsArr.length; j++) {
      let selectedModifier = {
        title: this.noOptionsArr[j].title,
        price: this.noOptionsArr[j].price
      };
      noOptions.options.push(selectedModifier);
    }
    this.productModifierDataArray.forEach(element => {
      var val = 0;
      let obj = {
        quantityTotal: 1,
        id: element.id,
        name: element.name,
        image: element.image,
        inventory_count: element.inventory_count,
        cash_tax: element.cash_tax,
        card_tax: element.card_tax,
        variantName: element.variantName,
        optionValue: element.optionValue,
        price: this.addItValue,
        is_on_sale: element.is_on_sale,
        variant_id: element.variant_id,
        modifiers: [],
        addons: { options: [] },
        no_options: { options: [] },
        hasModifier: true,
        modifier_price_calculation: val,
        modifier_price_calculation_single: val,
        error_msg: ''
      };


      // if (this.checkObjectVariantModifier(this.productModifierDataArray, obj) === false) {
      //   this.productDisplayDataArray.push(obj);
      // }
      obj.modifiers = modifiers;
      obj.addons = addons;
      obj.no_options = noOptions;
      // Checking Same Varient //
      var index: any;
      let returnObj = this.checkObjectModifier(this.productDisplayDataArray, obj);
      if (returnObj.value === false) {
        this.productDisplayDataArray.push(obj);
        index = this.productDisplayDataArray.indexOf(obj);
      }
      else {

        if (returnObj.index === -1) {
          index = this.productDisplayDataArray.indexOf(obj);
          this.productDisplayDataArray[index]['quantityTotal'] += 1;
        }
        else {
          index = returnObj.index;
          this.productDisplayDataArray[returnObj.index]['quantityTotal'] += 1;
        }
      }
      // this.productDisplayDataArray[this.ind] = obj;
      // this.productDisplayDataArray.push(obj);
      // const index = this.checkValUpdateVariant(this.productDisplayDataArray, obj);
      //const index = this.productDisplayDataArray.indexOf(obj);

      // this.productCalculation(this.productDisplayDataArray[index].variant_id, this.productDisplayDataArray[index].price, this.productDisplayDataArray[index].quantityTotal, this.productDisplayDataArray[index].cash_tax, this.productDisplayDataArray[index].card_tax, index);
      this.reInitializeCalculationArray();
      $('#addVariantsModifiersPop').modal('hide');
      this.productModifierDataArray = [];
      this.modifiersArr = [];
      this.addonsArr = [];
      this.noOptionsArr = [];
    });

  }

  setSearchProductOnOrder() {
    this.dataService.searchProducts(window.localStorage.getItem('token'), this.searchString, this.dispensary_id).subscribe(
      (data) => {
        this.productData = data;
        this.productDataLength = this.productData.length;
        for (var j = 0; j < this.OrderproductData.length; j++) {
          for (var i = 0; i < this.productDataLength; i++) {
            if (this.productData[i].id === this.OrderproductData[j].product_id) {
              if (this.productData[i].variant[0].id === this.OrderproductData[j].variant_id) {
                var obj = {
                  quantityTotal: this.OrderproductData[j].quantity,
                  id: this.productData[i].id,
                  name: this.productData[i].name,
                  image: this.productData[i].image,
                  variantName: this.productData[i].variant[0].option_name,
                  optionValue: this.productData[i].variant[0].option_value,
                  inventory_count: this.productData[i].inventory_count,
                  price: Math.round(this.productData[i].variant[0].price),
                  compare_price: Math.round(this.productData[i].variant[0].compare_price),
                  is_on_sale: this.productData[i].variant[0].is_on_sale,
                  variant_id: this.productData[i].variant[0].id,
                  error_msg: ''
                };

                if (this.checkObjectVariant(this.productDisplayDataArray, obj) === false) {
                  this.productDisplayDataArray.push(obj);
                }
                const index = this.checkValUpdateVariant(this.productDisplayDataArray, obj);

                this.productCalculationOnOrder(this.productDisplayDataArray[index].variant_id, this.productDisplayDataArray[index].price, this.productDisplayDataArray[index].quantityTotal, 0);
              }
            }
          }
        }

        this.customerDisplayDataArray = [];
        var number = this.customerDetail.id;
        this.prefindCustomerForDisplayData(number);

      },
      (error) => {
        console.log('error', error);
      }
    );
  }
  trigerQuantity() {
    $('#quantity0').trigger('select');
    var value = $('#quantity0').val();
  }

  infoPop(obj) {
    $('#infoPopOpen').modal('show');
  }

  ngOnInit() {
    // var timer;
    // var contax = this;
    // $('#orderSearchCtrate').keyup(function () {
    //   clearTimeout(timer);
    //   timer = setTimeout(function (event) {
    //     contax.searchProductOnOrder();
    //   }, 1000);
    // })

    this.dispensary_id = window.localStorage.getItem('despensId');


    this.searchOutletOnOrder();
    this.orderDetailCall();


    $('#paymentNoCheckCard').css('display', 'none');
    $('#paymentNoCheckCash').css('display', 'none');
    this.getBusinessProfile();
    this.getPlatformFeeFunction();
    setTimeout(() => {
      this.get_dispensary_information();
    }, 4000)
    $('input').on('focus', 'input[type=number]', function (e) {
      $(this).on('mousewheel.disableScroll', function (e) {
        e.preventDefault();
      });
    });
    $('input').on('blur', 'input[type=number]', function (e) {
      $(this).off('mousewheel.disableScroll');
    });
    // $('#discount').keyup(function(e) {
    //   console.log('asasasasasasa');
    //     if ($(this).val() > 100) {
    //        e.preventDefault();
    //     }
    // });
    // this.inputAddress1();
    // this.inputAddress3();
    $('.header').css('display', 'inline-block');
    $('.footer').css('display', 'inline-block');
    $('.clearSideSelecteion').css('color', '#3d3d3d');
    $('#order').css('color', '#d77229');
    $('.CustomerSearchBoxHide').css('display', 'none');
    $('.editAddressHide').css('display', 'none');
    $(function () {
      this.maxYear = new Date().getFullYear();
      this.maxYear = parseInt(this.maxYear) - 21;
      $('#datepicker').datepicker({
        format: 'mm/dd/yyyy', // Notice the Extra space at the beginning,
        defaultDate: '-10d',
        endDate: new Date('12/31/' + this.maxYear)
      });
      $('#phone').intlTelInput({
        // autoFormat: true,
        utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/12.1.9/js/utils.jss',
        autoPlaceholder: false,
        preferredCountries: ['GB'],
        preventInvalidNumbers: true,
        // stop the user from typing invalid dial codes
        preventInvalidDialCodes: true,
        formatOnDisplay: true,
        separateDialCode: false,
      });
      var countryCode;
      setTimeout(() => {
        countryCode = $('#phone').intlTelInput('getSelectedCountryData').dialCode;
        $('#phone').val('+' + countryCode);
      }, 1000);
      $('#phone').change(
        function () {
          countryCode = $('#phone').intlTelInput('getSelectedCountryData').dialCode;
          $('#phone').val('+' + countryCode);

        }
      );
    });

  }

  selectGender(val) {
    if (this.gender != val) {
      // this.showGender = true;
    }
    this.gender = val;
  }
}



// WEBPACK FOOTER //
// ./src/app/order-edit/order-edit.component.ts